
import { getCookie, simulateAsyncOperation, throttle } from 'mmbclient/Common/CommonFunctions';
import { calculateBookingFreightAmtForCourier, checkClientRateCourier, getClientRateCourier, getClientRatesForCourier, getZoningDetail } from 'mmbclient/Common/CommonMethodMMB';
import { calculateFriegthAmount, calculateFuelAmt, friegthAmount, getClientCommissionDetails, getInsuranceType } from 'mmbclient/Common/CommonMethods';
import { bookingViaMoney, getClientBalance } from 'mmbclient/Common/CommonRazorPay';
import { checkSession, getAllCityDataFromDb, getAllClients, getAllCountryDataFromDb, getAllPincodeFromDb, getAllStateDataFromDb, getClientAllDetail, getClientDetail, getClientVasViewDataFromDb, getClientViewDataFromDb, getCompanyFromDb, getConsigneeDetails, getConsignorDetails, getCountryDetails, getNetworkDataFromDb, getNetworkDetails, getPincodeDetails, getRecieverDataMMBFromDb, getServiceAssociatMMBDataFromDb, getServiceDataFromDb, getServiceDetails, getShipperDataMMBFromDb, getTatDaysFromDb, getTaxSeriesFromDb, loadAllMasterData } from 'mmbclient/Common/CommonService';
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, COMMON_LOADRECIEVERDETAIL, COMMON_LOADSHIPPERDETAIL, EP, EWAY_BILL, FAST_BOOKING_DOCKETJASPER, FAST_BOOKING_REQUEST_PATH, GLOBAL_CONTEXT, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, MASTERdATA, MMB, MMB_LIVE, PAGE_LOADING_TIME, STOCK_INCOMING, US, USER_TYPE_COOKIE_NAME, WALLET, WEIGTH_DIMENSION } from 'mmbclient/Common/CommonVariable';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify';


function CreditBookingController() {

    const store = useContext(GLOBAL_CONTEXT);
    const wallet = useContext(WALLET);

    // const {LIST_CLIENT, setLIST_CLIENT, 
    //         LIST_SERVICE, setlIST_SERVICE, 
    //         LIST_NETWORK, setLIST_NETWORK, 
    //         LIST_CITY, setLIST_CITY, 
    //         LIST_COUNTRY, setLIST_COUNTRY,
    //         LIST_PINCODE, setLIST_PINCODE,
    //         LIST_STATE, setLIST_STATE
    //     } = useContext(MASTERdATA);

    //pincode validation state 
    const [isValidating, setIsValidating] = useState(false);

    const dateRef = useRef(null);

    //masterdata gloabl
    const masterData = useContext(MASTERdATA);

    // toggle state for weigth modal
    const [showDimensionWeigthModal, setShowDimensionWeigthModal] = useState(false);

    // loading state
    const [loading,setLoading] = useState(false);
    
    const [originPin,setOriginPin] = useState('');
    const [disableAwb,setDisableAwb] = useState(false);
    const [modifyingData,setModifyingData] = useState({});
    
    
    const [date,setDate] = useState(new Date())
    const [isSaveDisable,setIsSaveDisable] = useState(true);
    const [dimensionList,setDimensionList] = useState([]);

   // for only pincode
    const [pincodeList, setPincodeList] = useState([]);

    //filterring state variable
    const [filteredOriginPincodes,setFilteredOriginPincodes] = useState([]);
    const [filteredDestPincodes,setFilteredDestPincodes] = useState([]);
    const [filteredSenderPincodes,setFilteredSenderPincodes] = useState([]);
    const [filteredReceiverPincodes,setFilteredReceiverPincodes] = useState([]);
    const [activeOriginIndex,setActiveOriginIndex] = useState(0);
    const [activeDestIndex,setActiveDestIndex] = useState(0)
    const [activeSenderIndex,setActiveSenderIndex] = useState(0);
    const [activeReceiverIndex,setActiveReceiverIndex] = useState(0)

    const originPincodeRef = useRef(null);
    const destPincodeRef = useRef(null);
    const receiverPincodeRef = useRef(null);
    const senderPincodeRef = useRef(null);
    const [focusVolumeWeigth,setFocusVolumeWeigth] = useState(false);

    const [isNew,setIsNew] = useState(true);
    const [isModify,setIsModify] = useState(false);


    // load data store state
    const [client, setClient] = useState('');

    // client state for combobox
    const [clientOption, setClientOption] = useState([]);

    //service state that is going to load in combobox 
    const [service,setService] = useState(["Select..."])

    //network state for combobox of network
    const [network,setNetwork] = useState(["Select..."])

    const [fuelAmount,setFuelAmount] = useState(0);

    const SELECT = "Select..."

    const [senderList,setSenderList] = useState([]);

    const [receiverList,setReceiverList] = useState([]);

    const [printDocket,setPrintDocket] = useState(false);
    const [clientSelfSender,setClientSelfSender] = useState(false);

    const [isSameAwb,setIsSameAwb] = useState('');

    const [formValues, setFormValues] = useState({
        awbNo:'',
        forwardingNo:'',
        date:date,
        tatDate:date,
        client:'',
        subClient:'',
        network:SELECT,
        service:SELECT,
        originPincode:'',
        originCity:'',
        originCityCode:'',
        originStateCode:'',
        destPincode:'',
        destCity:'',
        destCityCode:'',
        destStateCode:'',
        lbZone:'',
        stateCode:'',
        docType:'dox',
        pcs:'',
        actualWt:'',
        volumneWt:'',
        billingWt:'',
        friegth:0,
        WEIGHT_SLAB_AMOUNT:0,
        WEIGHT_SLAB_TYPE:'',
        ZONE_CODE:'',
        fuelAmt:0,
        fuelRate:0,
        insInvoiceNo:'',
        insValue:0,
        insurance:'NA',
        insAmount:0,
        insRate:0,
        senderContact:'',
        senderName:'',
        senderAddress:'',
        senderPincode:'',
        senderCity:'',
        senderState:'',
        receiverContact:'',
        receiverName:'',
        receiverAddress:'',
        receiverPincode:'',
        receiverCity:'',
        receiverState:'',
        content:'',
        remarks:'',
        clientCode:getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : '',
        userType: getCookie(APP_TYPE_COOKIE_NAME),
        taxName1:'',
        taxRate1:0,
        service_tax:0,
        taxName2:'',
        taxRate2:0,
        edu_cess:0,
        taxName3:'',
        taxRate3:0,
        h_edu_Cess:0,
        total:0,
        codValue:0,
        codAmount:0,
        docketCharge:0,
        gstTotal:0,
        specialEntry:''
    })

    const [list_clientRatesCourier, setList_clientRatesCourier] = useState(new Map());

    const [insurType,setInsurType] = useState([]);

    const [weigthDimension,setWeigthDimension]  = useState({
        heigth:'',
        width:'',
        length:'',
        actwt:'',
        pcs:'',
        volwt:''
    });

    useEffect(()=>{
        const fetchData=async()=>{
            setLoading(true);
            try {
                // console.log("====================================",masterData.LIST_CLIENT);
                // console.log(masterData.isClientLoaded)
                // if(!masterData.isClientLoaded){
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                        loadAllServices(store),
                        loadAllNetwork(store),
                        loadAllPincode(store),
                        loadClientAllDetail(store),
                        loadClientVasAllDetail(store),
                    ]);
                    setTimeout(()=>{
                        masterData.setIsClientLoaded(true)
                    },0)
                    loadSenderAllDetail(store);
                    loadReceiverAllDetail(store);
                setAllData(masterData);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    },[]);

    // useEffect(() => {
    // }, [formValues]);

    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }

    const setAllData=(masterData)=>{
        let lst_Client = [];
        if (masterData.LIST_CLIENT.length > 0) {
            let i;
            for (i of masterData.LIST_CLIENT) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
            setClientOption(lst_Client);
            setFormValues(prev=>({
                ...prev,
                'client':lst_Client[0]
            }))
            
        }

        if(masterData.LIST_NETWORK.length>0){
            let lst_network=[];
            for(let i of masterData.LIST_NETWORK){
                lst_network.push(i.net_name + " | " + i.net_code)
            }
            setFormValues(prev=>({
                ...prev,
                'network':lst_network[0]
            }))
            setNetwork(lst_network);
        }

        if (masterData.LIST_SERVICE.length > 0) {
            let lst_service = []
            let i;
            for (i of masterData.LIST_SERVICE) {
                    lst_service.push(i.ser_name+" | "  + i.ser_code);
            }
            setFormValues(prev=>({
                ...prev,
                'service':lst_service[0]
            }))
            setService(lst_service);
        }

        if(masterData.LIST_PINCODE.length>0){
            const pincode = masterData.LIST_PINCODE.map(i => i.pin_code);

            setPincodeList(pincode);
        }
        
    }


    const loggerFunc = () => {
            checkSession(store);
            getClientBalance(wallet);
        }
    
    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    async function loadClientAllDetail(store) {
        // console.log("client response ",masterData.LIST_CLIENT);
        if(masterData.LIST_CLIENT.length>0){
            // console.log("returning from loadClientAllDetail");
            return;
        }

        const response = await getClientViewDataFromDb();
        let lst_Client = [];
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
            setClientOption(lst_Client);
            setFormValues(prev=>({
                ...prev,
                'client':lst_Client[0]
            }))
            masterData.setLIST_CLIENT(response);
            
        }
        console.log("all client",response);
    }

    async function loadClientVasAllDetail(store) {
        if(masterData.LIST_CLIENTVAS.length>0) return;
        const response = await getClientVasViewDataFromDb();
        if (response.length > 0) {
            masterData.setLIST_CLIENTVAS(response);
        }
        console.log("all client vas detail", response);
    }

    // loan network from server
    async function loadAllNetwork(store){
        if(masterData.LIST_NETWORK.length>0) return;
        const response = await getNetworkDataFromDb();
        let lst_network = [];
        let i;
        lst_network.push("Select...")
        if(response.length>0){
            
            for(i of response){
                lst_network.push(i.net_name + " | " + i.net_code)
            }
            console.log("network all detail", response);
            setFormValues(prev=>({
                ...prev,
                'network':lst_network[0]
            }))
            masterData.setLIST_NETWORK(response);
            setNetwork(lst_network);
        }
    }

    // load service from server
    async function loadAllServices(store) {
        if(masterData.LIST_SERVICE.length>0) return;
        const response = await getServiceDataFromDb();
        let lst_service = []
            let i;
            lst_service.push('Select...');
        if (response.length > 0) {
            for (i of response) {
                    lst_service.push(i.ser_name+" | "  + i.ser_code);
            }
            console.log("all service", response)
            setFormValues(prev=>({
                ...prev,
                'service':lst_service[0]
            }))
            masterData.setLIST_SERVICE(response)
        }
        setService(lst_service);
    }

    // load pincode from server
    async function loadAllPincode() {
        if(masterData.LIST_PINCODE.length>0) return;
        const response = await getAllPincodeFromDb();

        if (!response || response.length === 0) return;

        const pincode = response.map(i => i.pin_code);

        setPincodeList(pincode);
        masterData.setLIST_PINCODE(response);
        console.log("pincode",response);
        // console.log(response);
    }

    async function loadSenderAllDetail(store) {
        const response = await getShipperDataMMBFromDb();
        if (response.length > 0) {
            setSenderList(response);
        }
        // console.log("sender",response);
    }

    async function loadReceiverAllDetail(store) {
        const response = await getRecieverDataMMBFromDb();
        if (response.length > 0) {
            setReceiverList(response);
        }
        // console.log("receiver",response);
    }

    async function loadTatDays() {
        if(masterData.LIST_TATDAYS.length>0)return;
        const response = await getTatDaysFromDb();
        if(response.length>0){
            masterData.setLIST_TATDAYS(response);
        }
    }

    //filter origin pincode
    const filterOriginPincodes = (value) => {
        if (!value.trim()) {
            setFilteredOriginPincodes([]);
            return;
        }
        // const onlyPins = pincodeList.map(item => item.split('|')[0]);
        const filtered = pincodeList.filter(pin =>
            pin.startsWith(value)
        );
        setFilteredOriginPincodes(filtered);
    };

    // filtering dest pincode
    const filterDestPincodes = (value) => {
        if (!value.trim()) {
            setFilteredDestPincodes([]);
            return;
        }
        // const onlyPins = pincodeList.map(item => item.split('|')[0]);
        const filtered = pincodeList.filter(pin =>
            pin.startsWith(value)
        );
        setFilteredDestPincodes(filtered);
    };

    const filterReceiverPincodes = (value) => {
        if (!value.trim()) {
            setFilteredReceiverPincodes([]);
            return;
        }
        // const onlyPins = pincodeList.map(item => item.split('|')[0]);
        const filtered = pincodeList.filter(pin =>
            pin.startsWith(value)
        );
        setFilteredReceiverPincodes(filtered);
    };

    const filterSenderPincodes = (value) => {
        if (!value.trim()) {
            setFilteredSenderPincodes([]);
            return;
        }
        // const onlyPins = pincodeList.map(item => item.split('|')[0]);
        const filtered = pincodeList.filter(pin =>
            pin.startsWith(value)
        );
        setFilteredSenderPincodes(filtered);
    };

    const debouncedFilterOrigin = useMemo(() => debounce(filterOriginPincodes, 300), [pincodeList]);
    const debouncedFilterDest = useMemo(() => debounce(filterDestPincodes, 300), [pincodeList]);
    const debouncedFilterReceiver = useMemo(() => debounce(filterReceiverPincodes, 300), [pincodeList]);
    const debouncedFilterSender = useMemo(() => debounce(filterSenderPincodes, 300), [pincodeList]);

    // handle input regex
    const handleInputChange=(event)=>{
        const { name, type, checked, value } = event.target;

        if (name === 'awbNo') {
            if (value === '' ||
                (value.length <= 25 && /^[a-zA-Z0-9]*$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value.toUpperCase()
                }));
            }
        } 
        // else if (name === 'forwardingNo') {
        //     if (value === '' ||
        //         (value.length <= 25 && /^[a-zA-Z0-9]*$/.test(value))) {
        //         setFormValues(prev=>({
        //             ...prev,
        //             [name]: value.toUpperCase()
        //         }));
        //     }
        // }
        else if(name==="originPincode"){
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value
                }));
                debouncedFilterOrigin(value);
            }
        }
        else if (name === 'destPincode') {
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value
                }));
                debouncedFilterDest(value);
            }
        }
        else if(name==='client'){
            setFormValues(prev=>({
                ...prev,
                [name] : value
            }))
        }
        else if(name==='insurance'){
            setFormValues(prev=>({
                ...prev,
                [name]:value
            }))

            console.log('insurance',value);
            console.log('insurance',formValues)
        }
        else if(name==='senderContact'){
            if (value === '' ||
                (value.length <= 10 && /^\d{0,10}$/.test(value))) {
                setFormValues(prev=>({
                ...prev,
                [name]:value
                }))
            }
            // console.log(value,name,checked);
        }
        else if(name==='receiverContact'){
            if (value === '' ||
                (value.length <= 10 && /^\d{0,10}$/.test(value))) {
                setFormValues(prev=>({
                ...prev,
                [name]:value
                }))
            }
            // console.log(value,name,checked);
        }else if(name==="receiverPincode"){
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value
                }));
                debouncedFilterReceiver(value);
            }
        }
        else if(name==="senderPincode"){
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value
                }));
                debouncedFilterSender(value);
            }
        }
        else if(name==='printDocket'){
            setPrintDocket(type === "checkbox" ? checked : value);
            // console.log(value,name,checked);
        }
        else if(name==='selfClientSender'){
            setClientSelfSender(type === "checkbox" ? checked : value);
            console.log(value,name,checked);
            if(checked){
                const clientCode = formValues.client?.split("|")[1]?.trim();
                for(let clientBean of masterData.LIST_CLIENT){
                    if(clientCode===clientBean.client_code){
                        setFormValues(prev=>({
                            ...prev,
                            'senderContact':clientBean.contact_number?clientBean.contact_number:'',
                            'senderName':clientBean.client_name?clientBean.client_name:'',
                            'senderAddress':clientBean.client_address?clientBean.client_address:'',
                        }))
                        selectSenderPincode(clientBean.zip_code);
                        console.log(clientBean);
                        break;
                    }
                }
            }else{
                setFormValues(prev=>({
                    ...prev,
                    'senderContact':'',
                    'senderName':'',
                    'senderAddress':'',
                    'senderPincode':'',
                    'senderCity':'',
                    'senderState':''
                }))
            }
        }
        else{
            setFormValues(prev=>({
                ...prev,
                [name]:value
            }))
        }
    }

    const [entryType, setEntryType] = useState("new");

    const handleEntryChange = (event) => {
        resetAction();
        setEntryType(event.target.value);
    };

    const handleNewModifyAwb=(event)=>{

        if(formValues.awbNo==='')return;

        if(entryType==='new'){
            console.log("new")
            return checkAwbNo(event);
        }else if(entryType==='modify'){
            console.log("modify")
            awbBlurHandle();
        }
    }


    const handleBlurSender=(event)=>{
        const { name,value } = event.target;
        if(clientSelfSender)return;
        for(let sender of senderList){
            if(sender.ship_ph===value){
                setFormValues(prev=>({
                    ...prev,
                    [name]:sender.ship_ph,
                    'senderName':sender.ship_name,
                    'senderAddress':sender.ship_addrs,
                    'senderPincode':sender.ship_zip||'',
                    'senderCity':sender.ship_city?sender.ship_city.length<=3?sender.ship_city:'':'',
                    'senderState':sender.ship_state?sender.ship_state.length<=3?sender.ship_state:'':'',
                }))
            }
        }
    }

    const handleBlurReceiver=(event)=>{
        const { name,value } = event.target;
        for(let recv of receiverList){
            if(recv.recv_ph===value){
                setFormValues(prev=>({
                    ...prev,
                    [name]:recv.recv_ph,
                    'receiverName':recv.recv_name,
                    'receiverAddress':recv.recv_addrs,
                    // 'receiverPincode':recv.recv_zip?recv.recv_zip:'',
                    // 'receiverCity':recv.recv_city?recv.recv_city.length<=3?recv.recv_city:'':'',
                    // 'receiverState':recv.recv_state?recv.recv_state.length<=3?recv.recv_state:'':''
                }))
            }
        }
    }

    const handleDecimalInputChange=(event)=>{
        const {name,value} = event.target
            if (/^\d*\.?\d*$/.test(value)) {
                setFormValues(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
    }

    const handleBlurOfVolumeWt= async()=>{
        const actual = Number(formValues.actualWt);
        const volume = Number(formValues.volumneWt);

        const billingWeight = actual > volume ? actual : volume;
        setFormValues(prev=>({
            ...prev,
            'billingWt':billingWeight
        }))

        const client = formValues.client.split('|')[1].trim();
        const service = formValues.service.split('|')[1].trim();
        const serviceGroup = getServiceGroupCode();
        const network = formValues.network.split('|')[1].trim();
        // let insurType = getInsuranceType(masterData,client,serviceGroup,network)
        // // console.log(client,service,network,serviceGroup)
        // // console.log("insurance",insurType);
        // if(insurType==='OW'){
        //     insurType = 'Owner';
        // }else if(insurType==='CA'){
        //     insurType = 'Carrier';
        // }else{
        //     alert("Client insurance type not found");
        // }
        // setFormValues(prev=>({
        //     ...prev,
        //     'insurance':insurType
        // }))

        let destinationCode = formValues.destCityCode;
        let documentType = '';
        if(formValues.docType==='dox'){
            documentType='D'
        }else{
            documentType='N'
        }
        let freigthObj = await calculateBookingFreightAmtForCourier(masterData,client,network,serviceGroup,destinationCode,'DO',billingWeight,documentType)
        console.log(freigthObj,"freigth");

        setFormValues(prev=>({
            ...prev,
            'friegth':freigthObj.amt,
            'WEIGHT_SLAB_AMOUNT':freigthObj.WEIGHT_SLAB_AMOUNT,
            'WEIGHT_SLAB_TYPE':freigthObj.WEIGHT_SLAB_TYPE,
            'ZONE_CODE':freigthObj.ZONE_CODE
        }))
    }

    // const onFriegthEnter =async ()=>{

    //     await calculateTax();
        
    // }

    const handleWeigthDecimalInputChange=(event)=>{
        const {name,value} = event.target
            if (/^\d*\.?\d*$/.test(value)) {
                setWeigthDimension(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
    }

    const handleNumberInputChange=(event)=>{
        const {name,value} = event.target
        if (/^\d*$/.test(value)) {
            setFormValues(prev => ({
                ...prev,
                [name]: value
            }));
        }
    }

    const handleBlurPincode =async (type) => {
        try {
            setLoading(true);
            if ("originPincode" === type) {
                // setFormValues({
                //     ...formValues,
                //     'originCity': '',
                //     'originCityCode':'',
                //     'originStateCode':''
                // });

                setFormValues(prev=>({
                    ...prev,
                    'originCity': '',
                    'originCityCode':'',
                    'originStateCode':''
                }))
                const name = 'originCity';
                if (formValues.originPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of masterData.LIST_PINCODE) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    const cityCode = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    // const countryCode = currentValue.country_code;
                    if (pincode === formValues.originPincode) {
                        // setFormValues({
                        //     ...formValues,
                        //     [name]: cityName,
                        //     'originPincode':pincode,
                        //     'originCityCode':cityCode,
                        //     'originStateCode':stateCode
                        // });
                        setFormValues(prev=>({
                            ...prev,
                            [name]: cityName,
                            'originPincode':pincode,
                            'originCityCode':cityCode,
                            'originStateCode':stateCode
                        }))
                        setLoading(false);
                        return;
                    }
                }
            } else if ("destPincode" === type) {
                // setFormValues({
                //     ...formValues,
                //     'destCity': '',
                //     'destCityCode': '',
                //     'destStateCode': '',
                // });

                setFormValues(prev=>({
                    ...prev,
                    'destCity': '',
                    'destCityCode': '',
                    'destStateCode': '',
                }))
                const name = 'destCity';
                if (formValues.destPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of masterData.LIST_PINCODE) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    const cityCode = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    // const countryCode = currentValue.country_code;
                    if (pincode === formValues.destPincode) {
                        setFormValues(prev=>({
                            ...prev,
                            'destPincode': pincode,
                            [name]:cityName,
                            'destCityCode': cityCode,
                            'destStateCode': stateCode,
                            'stateCode': stateCode,
                            'receiverPincode':pincode,
                            'receiverCity':cityCode,
                            'receiverState':stateCode
                        }))
                        setLoading(false);
                        return;
                    }
                }
            }else if ("senderPincode" === type) {
                // setFormValues({
                //     ...formValues,
                //     'senderCity': '',
                //     'senderState': '',
                // });

                setFormValues(prev=>({
                    ...prev,
                    'senderCity': '',
                    'senderState': '',
                }))
                const name = 'senderCity';
                console.log(formValues);
                if (formValues.senderPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                console.log(formValues);
                for (const currentValue of masterData.LIST_PINCODE) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    // const countryCode = currentValue.country_code;
                    if (pincode === formValues.senderPincode) {
                        console.log('formValues.senderPincode',formValues.senderPincode)
                        console.log('pincode',cityName)
                        // console.log('countryCode',countryCode)
                        console.log('stateCode',stateCode)
                        // setFormValues({
                        //     ...formValues,
                        //     [name]: cityName,
                        //     'senderPincode': pincode,
                        //     'senderState': stateCode,
                        // });
                        setFormValues(prev=>({
                            ...prev,
                            [name]: cityName,
                            'senderPincode': pincode,
                            'senderState': stateCode,
                        }))
                        setLoading(false);
                        return;
                    }
                }
            }else if ("receiverPincode" === type) {
                // setFormValues({
                //     ...formValues,
                //     'receiverCity': '',
                //     'receiverState': '',
                // });
                setFormValues(prev=>({
                    ...prev,
                    'receiverCity': '',
                    'receiverState': '',
                }))
                const name = 'receiverCity';
                if (formValues.receiverPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of masterData.LIST_PINCODE) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    // const countryCode = currentValue.country_code;
                    if (pincode === formValues.receiverPincode) {
                        console.log('formValues.senderPincode',formValues.receiverPincode)
                        console.log('pincode',pincode)
                        // console.log('countryCode',countryCode)
                        console.log('stateCode',stateCode)
                        // setFormValues({
                        //     ...formValues,
                        //     'receiverPincode': pincode,
                        //     [name]: cityName,
                        //     'receiverState': stateCode,
                        // });

                        setFormValues(prev=>({
                            ...prev,
                            'receiverPincode': pincode,
                            [name]: cityName,
                            'receiverState': stateCode,
                        }))
                        setLoading(false);
                        return;
                    }
                }
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }

        // try {

        //     const isValid = masterData.LIST_PINCODE.find(
        //         pin => pin.pin_code === value
        //     );

        //     if (isValid===undefined) {
        //         setIsValidating(true);
        //         if(name === 'originPincode'){
        //             setFormValues(prev=>({
        //                 ...prev,
        //                 "originCity": '',
        //                 "originCityCode":'',
        //                 'originStateCode':''
        //             }))
        //         }else if(name==='destPincode'){
        //             setFormValues(prev=>({
        //                 ...prev,
        //                 'destCity': '',
        //                 'stateCode':'',
        //                 'destCityCode':'',
        //                 'destStateCode':'',
        //                 'lbZone':''
        //             }));
        //         }else if(name==='receiverPincode'){
        //             setFormValues(prev=>({
        //                 ...prev,
        //                 'receiverCity':'',
        //                 'receiverState':''
        //             }))
        //         }
        //         else if(name==='senderPincode'){
        //             setFormValues(prev=>({
        //                 ...prev,
        //                 'senderCity':'',
        //                 'senderState':''
        //             }))
        //         }
        //         setTimeout(() => {
        //             if(name === 'originPincode'){
        //                 originPincodeRef.current?.blure();
        //             }
        //             else if(name === 'destPincode'){
        //                 destPincodeRef.current?.blure();
        //             }
        //             else if(name === 'receiverPincode'){
        //                 receiverPincodeRef.current?.blure();
        //             }
        //             else if(name === 'senderPincode'){
        //                 senderPincodeRef.current?.blure();
        //             }

        //             setIsValidating(false);
        //         }, 0);
        //     }else{
        //         setIsValidating(true);
        //         if(name === 'originPincode'){
        //             // console.log("from orgiin pincde")
        //             selectOriginPincode(isValid.pin_code) ;
        //         }else if(name==='destPincode'){
        //             // console.log("from destPincode pincde")
        //             selectDestPincode(isValid.pin_code);
        //         }else if(name==='receiverPincode'){
        //             selectReceiverPincode(isValid.pin_code);
        //         }else if(name==='senderPincode'){
        //             selectSenderPincode(isValid.pin_code);
        //         }

        //         setTimeout(() => {
        //             setIsValidating(false);
        //         }, 0);
        //     }

        // } catch (error) {
        //     console.log(error);
        // }
    };



    const selectOriginPincode=async(value)=>{
        setFormValues(prev=>({
                    ...prev,
                    "originCity": '',
                    "originCityCode":'',
                    'originStateCode':''
                }
                ));
        for(const i of masterData.LIST_PINCODE){
            if (value === i.pin_code) {
                setFormValues(prev=>({
                    ...prev,
                    "originPincode": i.pin_code,
                    "originCity": i.city_name,
                    "originCityCode":i.city_code,
                    'originStateCode':i.state_code
                }
                ));
                break;
            }
        }

    setFilteredOriginPincodes([]);
    }


    const selectDestPincode = (item) => {
        setFormValues(prev=>({
                ...prev,
                'destCity': '',
                'stateCode':'',
                'destCityCode':'',
                'destStateCode':'',
                'lbZone':''
            }));
        let findPincode = false;
    for (const i of masterData.LIST_PINCODE) {
        if (i.pin_code === item) {
            setFormValues(prev=>({
                ...prev,
                'destPincode': i.pin_code,
                'destCity': i.city_name,
                'stateCode':i.state_code,
                'destCityCode':i.city_code,
                'destStateCode':i.state_code,
                'lbZone':i.zone_code
            }));
            findPincode = true;
            setTateDate(i.zone_code)
            break;
        }
    }

    setFilteredDestPincodes([]);
    };

    const selectSenderPincode = (item) => {
        setFormValues(prev=>({
            ...prev,
            'senderCity': '',
            'senderState':'',
        }));
        let findPincode = false;
    for (const i of masterData.LIST_PINCODE) {
        if (i.pin_code === item) {
            console.log('pincode from select',i)
            setFormValues(prev=>({
                ...prev,
                'senderPincode': i.pin_code,
                'senderCity': i.city_code,
                'senderState':i.state_code,
            }));
            break;
        }
    }
    setFilteredSenderPincodes([]);
    };

    const selectReceiverPincode = (item) => {
        setFormValues(prev=>({
                ...prev,
                'receiverCity': '',
                'receiverState':''
            }));
        let findPincode = false;
    for (const i of masterData.LIST_PINCODE) {
        if (i.pin_code === item) {
            setFormValues(prev=>({
                ...prev,
                'receiverPincode': i.pin_code,
                'receiverCity': i.city_code,
                'receiverState':i.state_code
            }));
            findPincode = true;
            break;
        }
    }

    setFilteredReceiverPincodes([]);
    };

    const setTateDate=(zonecode)=>{
        if(formValues.service==='Select...')return;
        let days = 1;
        const service = formValues.service.split("|")[1].trim();
        const serviceGroupCode = getServiceGroupCode();
        for(let tat of masterData.LIST_TATDAYS){
            if (tat.zone_code===zonecode && tat.service_code===serviceGroupCode) {
                days = tat.tat_days;
                break;
            }
        }

            // add days to date
        const newDate = new Date(formValues.date);
        newDate.setDate(newDate.getDate() + days);
        setFormValues(prev=>({
            ...prev,
            'tatDate':newDate
        }))
    }
    const [isAwbExist,setAwbExists] = useState(false);
    const checkAwbNo=async(event)=>{
        if(formValues.awbNo==='') return;
        try{

            setLoading(true);
            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let column=''
            let condition = ''
            let tableBean = 'stock'
            if (c.length === 4) {

                if(cookieUserType==='MMB_LIVE'){
                    
                    return;
                }else if(cookieUserType==='MMB'){
                    
                }

                let query = { "userKey": c[0],"appType":cookieUserType,"awbno":formValues.awbNo,'beanname':tableBean};
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query),
                        key:"checkService"
                    })
                };
                const path = API_PATH + STOCK_INCOMING + "checkawbnoexists";
                const res = await fetch(path, requestOptions);
                const data = await res.json();

                const response = data[0][tableBean];
                console.log(response[0])
                if(response[0].count>0){
                    setAwbExists(true);
                    return 1;
                }else{
                    // alert("AWB NO. not exists.")
                    callToastWarnAlert(`Awb: ${formValues.awbNo}! Not Exists.`,2400)
                    setAwbExists(false);
                    resetAction();
                    event.focus();
                    return 0;
                }
            }
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }


    // ================================================== use enter as tab Key =========================================================
    const handleEnterAsTab =async (e) => {
    // Skip if dropdown/autocomplete is active
    if (
        e.key === "Enter" &&
        e.target.tagName !== "TEXTAREA"
    ) {
        e.preventDefault();

        const form = e.target.form;
        const elements = Array.from(form.elements);
        const index = elements.indexOf(e.target);
        console.log(elements[index].value);
        if(elements[index].name==='awbNo'){
            setIsSaveDisable(true);
            const count = handleNewModifyAwb(elements[index]);
            if(count==0){
                elements[index].focus();
                dateRef.current.setOpen(false);
                setIsSaveDisable(true);
                return;
            }
            
        }
        else if(elements[index].name === 'client'){

            let clientCode = formValues.client?.split('|')[1]?.trim();
            for(const clientBean of masterData.LIST_CLIENT){
                if(clientBean.client_code === clientCode){
                    selectOriginPincode(clientBean.zip_code||'')
                    break;
                }
            }
            let hashMap_ClientRatesCourier = await getClientRatesForCourier(clientCode);
            console.log("from enter client",hashMap_ClientRatesCourier);
            setList_clientRatesCourier(hashMap_ClientRatesCourier);
            setIsSaveDisable(true);
        }
        else if(elements[index].name==='network'){
            if(formValues.network === SELECT){
                requestFocusOnInvalid(e,'network')
                setIsSaveDisable(true);
                callToastWarnAlert("Please Select network",2000)
                return;
            }
            setIsSaveDisable(true);
        }
        else if(elements[index].name === 'service'){

            if(formValues.service === SELECT){
                setIsSaveDisable(true);
                requestFocusOnInvalid(e,'service')
                callToastWarnAlert("Please Select Service",2000)
                return;
            }else if(formValues.network === SELECT){
                setIsSaveDisable(true);
                requestFocusOnInvalid(e,'network')
                callToastWarnAlert("Please Select network",2000)
                return;
            }

            setClientInsuranceType();
            setIsSaveDisable(true);
        }
        else if(elements[index].name === 'insValue'){
            if(formValues.service === SELECT){
                setIsSaveDisable(true);
                requestFocusOnInvalid(e,'service')
                callToastWarnAlert("Please Select Service",2000)
                return;
            }else if(formValues.network === SELECT){
                requestFocusOnInvalid(e,'network')
                setIsSaveDisable(true);
                callToastWarnAlert("Please Select network",2000)
                return;
            }
            if(Number(formValues.insValue)>0){
                calculateInsuranceAmount();
            }else{
                setFormValues(prev=>({
                    ...prev,
                    'insAmount':0,
                    'insRate':0
                }))
            }
            setIsSaveDisable(true);
        }
        else if(elements[index].name === 'pcs'){
            if(!formValues.pcs){
                setFormValues(prev=>({
                    ...prev,
                    'pcs':1
                }))
            }
        }
        else if(elements[index].name === 'actualWt'){
            if(!formValues.actualWt){
                setFormValues(prev=>({
                    ...prev,
                    'actualWt':"0.100"
                }))
            }
            if(formValues.docType==='non-dox'){
                setShowDimensionWeigthModal(true);
                setIsSaveDisable(true);
            }
        }
        else if(elements[index].name === 'volumneWt'){

            if(!formValues.volumneWt){
                setFormValues(prev=>({
                    ...prev,
                    'volumneWt':"0.100"
                }))
            }

            if(formValues.service === SELECT){
                
                requestFocusOnInvalid(e,'service')
                callToastWarnAlert("Please Select Service",2000)
                setIsSaveDisable(true);
                return;
            }else if(formValues.network === SELECT){
                requestFocusOnInvalid(e,'network')
                callToastWarnAlert("Please Select network",2000)
                setIsSaveDisable(true);
                return;
            }
            handleVolumeEnter();
            setIsSaveDisable(true);
        }
        else if(elements[index].name === 'codValue'){
            if(formValues.service === SELECT){
                
                requestFocusOnInvalid(e,'service')
                callToastWarnAlert("Please Select Service",2000)
                setIsSaveDisable(true);
                return;
            }else if(formValues.network === SELECT){
                requestFocusOnInvalid(e,'network')
                callToastWarnAlert("Please Select network",2000)
                setIsSaveDisable(true);
                return;
            }
            const client = formValues.client.split('|')[1].trim();
            const service = formValues.service.split('|')[1].trim();
            const serviceGroup = getServiceGroupCode();
            const network = formValues.network.split('|')[1].trim();
            const codValue = Number(formValues.codValue||0);
            
            getDocketChargeAndCodAmt(client,serviceGroup,network,codValue);
            let freigth = formValues.friegth;
            let insAmt = formValues.insValue?formValues.insAmount:0;
            const codAmt = Number(formValues.codAmount)||0;
            let docketCharge = formValues.docketCharge||0;
            
            let fuelAmt = getFuelAmount(client,serviceGroup,network,freigth,insAmt,docketCharge,0,codAmt);
            calculateTax(fuelAmt);
            setIsSaveDisable(false);
        }
        else if(elements[index].name === 'friegth'){
            if(formValues.service === SELECT){
                
                requestFocusOnInvalid(e,'service')
                callToastWarnAlert("Please Select Service",2000)
                setIsSaveDisable(true);
                return;
            }else if(formValues.network === SELECT){
                requestFocusOnInvalid(e,'network')
                callToastWarnAlert("Please Select network",2000)
                setIsSaveDisable(true);
                return;
            }
            
        }
        if(elements[index].name === 'saveBtn'){
            checkValidation(e);
            setIsSaveDisable(true);
            return;
        }
        else if(elements[index].name ==='originPincode'){
            if (
                activeOriginIndex >= 0 &&
                activeOriginIndex < filteredOriginPincodes.length
            ) {
                selectOriginPincode(filteredOriginPincodes[activeOriginIndex]);
            }
            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];
            // const pincodeValue = elements[index].value;

            const isValid = masterData.LIST_PINCODE.find(
                pin => pin.pin_code === pincodeValue
            );

            if (!isValid) {
                setIsSaveDisable(true);
                requestFocusOnInvalid(e,'originPincode')
                // callToastWarnAlert('Enter valid pincode',2400)
                return;
            }
            setIsSaveDisable(true);
            
        }
        else if(elements[index].name === 'destPincode'){
            if (
                activeDestIndex >= 0 &&
                activeDestIndex < filteredDestPincodes.length
            ) {
                selectDestPincode(filteredDestPincodes[activeDestIndex]);
                selectReceiverPincode(filterDestPincodes[activeDestIndex]);
            }
            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];
            // const pincodeValue = elements[index].value;


            const isValid = masterData.LIST_PINCODE.find(
                pin => pin.pin_code === pincodeValue
            );
            // console.log(elements[index].name)
            if (!isValid) {
                setIsSaveDisable(true);
                requestFocusOnInvalid(e,'destPincode');
                // callToastWarnAlert('Enter valid Destination pincode',2400);
                return;
            }
            setIsSaveDisable(true);
        }
        else if(elements[index].name === 'senderPincode'){

            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];
            // const pincodeValue = elements[index].value;

            if (
                activeSenderIndex >= 0 &&
                activeSenderIndex < filteredSenderPincodes.length
            ) {
                selectSenderPincode(filteredSenderPincodes[activeSenderIndex]);
            }
            
        

            const isValid = masterData.LIST_PINCODE.find(
                pin => pin.pin_code === pincodeValue
            );
            // console.log(elements[index].name)
            if (!isValid) {
                requestFocusOnInvalid(e,'senderPincode')

                // callToastWarnAlert('Enter valid Sender pincode',2400);
                return;
            }else{
                selectSenderPincode(pincodeValue);

            }
            
        }
        else if(elements[index].name === 'receiverPincode'){
            // let pincodeValue = '';
            if (
                activeReceiverIndex >= 0 &&
                activeReceiverIndex < filteredReceiverPincodes.length
            ) {
                selectReceiverPincode(filteredReceiverPincodes[activeReceiverIndex]);
                // pincodeValue= filteredReceiverPincodes[activeReceiverIndex];
            }else{
                // pincodeValue = elements[index].value;
            }

            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];
            // const pincodeValue = elements[index].value;

            const isValid = masterData.LIST_PINCODE.find(
                pin => pin.pin_code === pincodeValue
            );
            // console.log(elements[index].name)
            if (!isValid) {
                requestFocusOnInvalid(e,'receiverPincode')
                // callToastWarnAlert('Enter valid Receiver pincode',2400)
                return;
            }else{
                selectReceiverPincode(pincodeValue)
            }

        }
        else if(elements[index].name === 'date'){
                dateRef.current.setOpen(false);
                setIsSaveDisable(true);
        }
        else if(elements[index].name === 'actualWt'){
            if(formValues.docType==='non-dox'){
                setShowDimensionWeigthModal(true);
                setIsSaveDisable(true);
            }
        }

        for (let i = index + 1; i < elements.length; i++) {
            if (
                elements[i].focus &&
                !elements[i].disabled &&
                elements[i].type !== "hidden"
            ) {
                elements[i].focus();
                break;
            }
        }
    }
};

const requestFocusOnInvalid=(e,name)=>{
    e.preventDefault();
    const form = e.target.form;
    const elements = Array.from(form.elements);
    // const index = elements.indexOf(e.target);
    for (let i = 0; i < elements.length; i++) {
        if(elements[i].name===name){
            elements[i].focus();
            break;
        }
    }
}


const handleEnterAsTabForVolumatric = (e) => {
    // Skip if dropdown/autocomplete is active
    if (
        e.key === "Enter" &&
        e.target.tagName !== "TEXTAREA"
    ) {
        e.preventDefault();

        const form = e.target.form;
        const elements = Array.from(form.elements);
        const index = elements.indexOf(e.target);

        if(elements[index].name==='actwt'){
            if(Number(formValues.actualWt)<=0){
                callToastWarnAlert("Actual Weigth must be greater than Zero.",2400);
            }
            enterDimensionMMB();
            elements[0].focus();
        }
        else if(elements[index].name==='pcs'){

            const totalPcs = Number(formValues.pcs);
            const currTotalPcs = dimensionList.reduce((total, item) => {
                return total + Number(item.pcs);
            }, 0);

            if(currTotalPcs===totalPcs){
                setShowDimensionWeigthModal(false)
                setFocusVolumeWeigth(true);
                return;
            };
        }
        else if(elements[index].name==='heigth'){
            if(Number(weigthDimension.heigth)<=0){
                callToastWarnAlert("Heigth must be greater than Zero.",2400);
                elements[index].focus();
                return;
            }
        }
        else if(elements[index].name==='width'){
            if(Number(weigthDimension.width)<=0){
                callToastWarnAlert("Width must be greater than Zero.",2400);
                elements[index].focus();
                return;
            }
        }
        else if(elements[index].name==='length'){
            if(Number(weigthDimension.length)<=0){
                callToastWarnAlert("Length must be greater than Zero.",2400);
                elements[index].focus();
                return;
            }
        }
        
        for (let i = index + 1; i < elements.length; i++) {
            if (
                elements[i].focus &&
                !elements[i].disabled &&
                elements[i].type !== "hidden"
            ) {
                elements[i].focus();
                break;
            }
        }
    }
};

    const awbBlurHandle=async()=>{
        if(formValues.awbNo==='') return;
        if(isSameAwb===formValues.awbNo)return;
        try{

            setLoading(true);
            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let column=''
            let condition = ''
            let tableBean = ''
            if (c.length === 4) {

                if(cookieUserType==='MMB_LIVE'){
                    return;
                }else if(cookieUserType==='MMB'){
                    column = "cb.awb_no AS 'awb_no',cb.fwd_no As forwarding_no,cb.branch_cd as branch_code,cb.client_cd as client_code,cb.sub_client_cd as sub_client_code,"
                            + "cb.boking_dt AS 'booking_date',cb.tat_date As tat_date, cb.network As 'network_code',"
                            + "cb.service As service_code,cb.pkgs AS packets,cb.type AS document_type,cb.vol_wt as volume_weight, cb.act_wt AS actual_weight,cb.bil_wt as billing_weight,cod_value,cod_amt,"
                            + "ifnull(cb.insur_type,'NA') as insurance_type,cb.insur_value as insurance_value, cb.insur_rate as insurance_rate, cb.insur_amt as insurance_amount, "
                            + "cb.cwc_amt,cb.fuel as fuel_amount,cb.special as special_entry,cb.ship_ph as sender_phone,"
                            + "cb.amount,cb.fuel,cb.fuel_rate,cb.docket_chrg,cb.zone_type,cb.weight_slab,cb.weight_type,"
                            + "cb.tax_name1,cb.tax_rate1,cb.service_tax,cb.tax_name2,cb.tax_rate2,cb.edu_cess,cb.tax_name3,cb.tax_rate3,cb.h_edu_Cess,cb.total,"
                            + "cb.origin_pincode as origin_pincode,cb.content as content,cb.pincode as pincode,cb.insur_invoice as insurance_invoice_no, "
                            + "cb.recv_ph as recv_ph,cb.comments as remarks,"
                            + "ifnull(ship.ship_name,'') as sender_name,"
                            + "ifnull(ship.ship_addrs,'')as sender_address,"
                            + "ifnull(ship.ship_zip,'') as sender_pincode,"
                            + "ifnull(ship.ship_city,'') as sender_city,"
                            + "ifnull(ship.ship_state,'') as sender_state,"
                            + "ifnull(recv.recv_name,'') as recv_name,"
                            + "ifnull(recv.recv_addrs,'') as recv_address,"
                            + "ifnull(recv.recv_zip,'') as recv_pincode,"
                            + "ifnull(recv.recv_city,'') as recv_city,"
                            + "ifnull(recv.recv_state,'') as recv_state";
                    tableBean = "DataEntryBean";
                    if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                        condition = "where cb.awb_no='" + formValues.awbNo + "'";
                    }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                        condition = "where cb.awb_no='" + formValues.awbNo + "'";
                    }
                }

                let query = { "userKey": c[0], 'column':column,'value':condition,'beanname':tableBean};
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query),
                        key:"checkService",
                        userType:cookieUserType
                    })
                };
                const path = API_PATH + FAST_BOOKING_REQUEST_PATH + "getdataviaawbno";
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                // console.log(data);

                const response = data[0][tableBean];
                if(response!=="Result Not Found"){
                    const detailValues = response[0];
                    const max = new Date();
                    max.setHours(0,0,0,0);

                    const min = new Date();
                    min.setDate(min.getDate() - 1);
                    min.setHours(0,0,0,0);

                    const checkDate = new Date(detailValues.booking_date);
                    checkDate.setHours(0,0,0,0);

                    if(cookieUserType===MMB_LIVE){
                    }
                    else if(cookieUserType===MMB){
                        // console.log(detailValues)
                        if (checkDate >= min && checkDate <= max) {
                            setModifyingAwbValuesMMB(detailValues);
                        } else {
                            setIsSaveDisable(true);
                            setUnModifyingAwbValuesMMB(detailValues);
                        }
                    }
                }else{
                    setIsSameAwb(formValues.awbNo);
                }
            }
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    const [modifying,setModifying] = useState(false);

    const setModifyingAwbValuesMMB=(data)=>{
        const clientCode = data.client_code;
        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === clientCode
        );

        if(selectedClient===undefined){
            toast.warn(`${data.awb_no} already booked by another customer.`, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
            resetAction();
            return;
        }

        // const confirmation = window.confirm("Do you want to modify?\nAwb No. " + formValues.awbNo);
        // if(confirmation){
        //     setModifying(true);
        //     // console.log(data)
        // }else{
        //     resetAction();
        //     return;
        // }

        setModifying(true);

        setModifyingData(data);
        setDisableAwb(true);
        selectOriginPincode(data.origin_pincode);
        selectDestPincode(data.pincode);
        const serviceCode = data.service_code;
        const networkCode = data.network_code;
        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === serviceCode
        );
        const selectNetwork = masterData.LIST_NETWORK.find(
            n=> n.net_code=== networkCode
        )
        const insuranceMap = {
            OW: 'Owner',
            CA: 'Carrier',
            NA: 'NA',
        };
        const serviceName = selectedService?.ser_name?selectedService.ser_name.trim():'';
        const serviceCd = selectedService?.ser_code?selectedService.ser_code.trim():'';
        const networkName = selectNetwork?.net_name?selectNetwork.net_name:'';
        const networkcd =  selectNetwork?.net_code?selectNetwork.net_code:'';
        // console.log("netwr",selectNetwork)
        // console.log(service)
        // console.log(network);
        setClient(selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase())
        let h_edu_Cess = data.h_edu_Cess||0;
        let edu_Cess = data.edu_cess||0;
        let taxService = data.service_tax||0;
        let totalGst = taxService  + edu_Cess + h_edu_Cess;
        setFormValues(prev=>({
            ...prev,
            'awbNo': data.awb_no,
            'forwardingNo': data.forwarding_no,
            'date': data.booking_date,
            'tatDate':data.tat_date,
            'subClient': data.sub_client_code,
            'docType': data.document_type==='D'?'dox':'non-dox',
            'pcs': data.packets,
            'actualWt': data.actual_weight,
            'volumneWt': data.volume_weight,
            'billingWt': data.billing_weight,
            'insInvoiceNo':data.insurance_invoice_no,
            'insValue':data.insurance_value,
            'insurance':insuranceMap[data.insurance_type] || '',
            'senderContact':data.sender_phone,
            'senderName':data.sender_name,
            'senderAddress':data.sender_address,
            'senderPincode':data.sender_pincode?data.sender_pincode:'',
            'senderCity':data.sender_city?data.sender_city.length<=3?data.sender_city : '':'',
            'senderState':data.sender_state?data.sender_state.length<=3?data.sender_state : '':'',
            'receiverContact':data.recv_ph,
            'receiverName':data.recv_name,
            'receiverAddress':data.recv_address,
            'receiverPincode':data.recv_pincode?data.recv_pincode:'',
            'receiverCity':data.recv_city?data.recv_city.length<=3?data.recv_city : '':'',
            'receiverState':data.recv_state?data.recv_state.length<=3?data.recv_state : '':'',
            'content': data.content,
            'remarks': data.remarks,
            'service': serviceName + " | " + serviceCd ,
            'network': networkName + " | " + networkcd,
            'client': selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase(),
            'friegth':data.amount||0,
            'fuelAmt':data.fuel||0,
            'fuelRate':data.fuel_rate||0,
            'docketCharge':data.docket_chrg||0,
            'ZONE_CODE':data.zone_type||'',
            'WEIGHT_SLAB_AMOUNT':data.weight_slab||0,
            'WEIGHT_SLAB_TYPE':data.weight_type||'',
            'taxName1':data.tax_name1||'',
            'taxRate1':data.tax_rate1||0,
            'service_tax': taxService,
            'taxName2':data.tax_name2||'',
            'taxRate2':data.tax_rate2||0,
            'edu_cess': edu_Cess,
            'taxName3':data.tax_name3||'',
            'taxRate3':data.tax_rate3||0,
            'h_edu_Cess': h_edu_Cess,
            'total':data.total||0,
            'gstTotal':totalGst,
            'codValue':data.cod_value,
            'codAmount':data.cod_amt
        }))
    }

    const setUnModifyingAwbValuesMMB=(data)=>{
        const clientCode = data.client_code;
        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === clientCode
        );

        if(selectedClient===undefined){
            alert(`${data.awb_no} already booked by another customer.`)
            resetAction();
            return;
        }else{
            alert("Awb No. already exist.");
        }

        setModifyingData(data);
        setDisableAwb(true);
        selectOriginPincode(data.origin_pincode);
        selectDestPincode(data.pincode);
        
        const serviceCode = data.service_code;
        const networkCode = data.network_code;
        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === serviceCode
        );

        const selectNetwork = masterData.LIST_NETWORK.find(
            n=> n.net_code=== networkCode
        )

        // const selectedClient = clientDetail.find(
        //     c => c.client_code === clientCode
        // );
        const insuranceMap = {
            OW: 'Owner',
            CA: 'Carrier'
        };
        setClient(selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase())
        const serviceName = selectedService?.ser_name?selectedService.ser_name.trim():'';
        const serviceCd = selectedService?.ser_code?selectedService.ser_code.trim():'';
        const networkName = selectNetwork?.net_name?selectNetwork.net_name:'';
        const networkcd =  selectNetwork?.net_code?selectNetwork.net_code:'';

        let h_edu_Cess = data.h_edu_Cess||0;
        let edu_Cess = data.edu_cess||0;
        let taxService = data.service_tax||0;
        let totalGst = taxService  + edu_Cess + h_edu_Cess;
        setFormValues(prev=>({
            ...prev,
            'awbNo': data.awb_no,
            'forwardingNo': data.forwarding_no,
            'date': data.booking_date,
            'subClient': data.sub_client_code,
            'tatDate':data.tat_date,
            'docType': data.document_type==='D'?'dox':'non-dox',
            'pcs': data.packets,
            'actualWt': data.actual_weight,
            'volumneWt': data.volume_weight,
            'billingWt': data.billing_weight,
            'insInvoiceNo':data.insurance_invoice_no,
            'insValue':data.insurance_value,
            'insurance':insuranceMap[data.insurance_type] || '',
            'senderContact':data.sender_phone,
            'senderName':data.sender_name,
            'senderAddress':data.sender_address,
            'senderPincode':data.sender_pincode?data.sender_pincode:'',
            'senderCity':data.sender_city?data.sender_city.length<=3?data.sender_city : '':'',
            'senderState':data.sender_state?data.sender_state.length<=3?data.sender_state : '':'',
            'receiverContact':data.recv_ph,
            'receiverName':data.recv_name,
            'receiverAddress':data.recv_address,
            'receiverPincode':data.recv_pincode?data.recv_pincode:'',
            'receiverCity':data.recv_city?data.recv_city.length<=3?data.recv_city : '':'',
            'receiverState':data.recv_state?data.recv_state.length<=3?data.recv_state : '':'',
            'content': data.content,
            'remarks': data.remarks,
            'service': serviceName + " | " + serviceCd ,
            'network': networkName + " | " + networkcd,
            'client': selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase(),
            'friegth':data.amount||0,
            'fuelAmt':data.fuel||0,
            'fuelRate':data.fuel_rate||0,
            'docketCharge':data.docket_chrg||0,
            'ZONE_CODE':data.zone_type||'',
            'WEIGHT_SLAB_AMOUNT':data.weight_slab||0,
            'WEIGHT_SLAB_TYPE':data.weight_type||'',
            'taxName1':data.tax_name1||'',
            'taxRate1':data.tax_rate1||0,
            'service_tax': taxService,
            'taxName2':data.tax_name2||'',
            'taxRate2':data.tax_rate2||0,
            'edu_cess': edu_Cess,
            'taxName3':data.tax_name3||'',
            'taxRate3':data.tax_rate3||0,
            'h_edu_Cess': h_edu_Cess,
            'total':data.total||0,
            'gstTotal':totalGst,
            'codValue':data.cod_value,
            'codAmount':data.cod_amt
        }))
    }

    const callToastWarnAlert=(message,duration)=>{
        toast.warn(message, {
                                autoClose: duration,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
    }

    const callToastSuccessAlert=(message,duration)=>{
        toast.success(message, {
                                autoClose: duration,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
    } 

    const callToastErrorAlert=(message,duration)=>{
        toast.error(message, {
                                autoClose: duration,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
    }  

    const checkValidation=(event)=>{

        if(formValues.awbNo===''){
            // alert("Enter awb no.")
            callToastWarnAlert(`Enter awb no.`,2400);
            requestFocusOnInvalid(event,'awbNo');
            setIsSaveDisable(true);
            return;
        }

        if(formValues.client===''){
            // alert("Select client");
            callToastWarnAlert(`Select client`,2400);
            requestFocusOnInvalid(event,'client');
            setIsSaveDisable(true);
            return;
        }

        if(formValues.network==='Select...'){
            // alert("select network")
            callToastWarnAlert(`Select network`,2400);
            requestFocusOnInvalid(event,'network');
            setIsSaveDisable(true);
            return;
        }

        if(formValues.service==="Select..."){
            // alert("Select service");
            callToastWarnAlert(`Select service`,2400);
            requestFocusOnInvalid(event,'service');
            setIsSaveDisable(true);
            return;
        }

        const pincodeRegex = /^[0-9]{6}$/;

        if (!pincodeRegex.test(formValues.originPincode)) {
            // alert("Enter valid origin pincode");
            callToastWarnAlert("Invalid! Origin Pincode",2400);
            requestFocusOnInvalid(event,'originPincode');
            setIsSaveDisable(true);
            return;
        }

        if (!pincodeRegex.test(formValues.destPincode)) {
            // alert("Enter valid destination pincode");
            callToastWarnAlert("Invalid! Destination Pincode",2400);
            requestFocusOnInvalid(event,'destPincode');
            setIsSaveDisable(true);
            return;
        }

        if(formValues.originCity==='' || formValues.destCity==='' || formValues.stateCode===''){
            alert("please enter valid pincode")
            setIsSaveDisable(true);
            return;
        }


        if(formValues.pcs<=0){
            // alert("Peice cannot be zero or negative");
            callToastWarnAlert("Invalid! Piece must be greater than Zero.",2400);
            requestFocusOnInvalid(event,'pcs');
            setIsSaveDisable(true);
            return;
        }

        if(Number(formValues.actualWt)<=0){
            // alert("Actual weigth cannot be zero or negative");
            callToastWarnAlert("Invalid! Actual Weigth must be greater than Zero.",2400);
            requestFocusOnInvalid(event,'actualWt');
            setIsSaveDisable(true);
            return;
        }

        if(Number(formValues.volumneWt)<=0){
            // alert("Volumne weigth cannot be zero or negative");
            callToastWarnAlert("Invalid! Volume Weigth must be greater than Zero.",2400);
            requestFocusOnInvalid(event,'volumneWt');
            setIsSaveDisable(true);
            return;
        }

        if(Number(formValues.friegth)<=0){
            callToastErrorAlert("Friegth can not be zero.",2400);
            // setFormValues(prev=>({
            //     ...prev,
            //     'specialEntry':'T'
            // }))
            setIsSaveDisable(true);
            return;
        }

        if(Number(formValues.total)<=0){
            callToastErrorAlert("Total can not be zero.",2400);
            setIsSaveDisable(true);
            return;
        }
        const contactNumberRegex = /^[0-9]{10}$/
        if(!contactNumberRegex.test(formValues.senderContact)){
            // alert("Incorrect Sender Phone number.");
            callToastWarnAlert("Invalid! Sender Phone number.",2400);
            requestFocusOnInvalid(event,'senderContact');
            return;
        }
        else if(formValues.senderName===''){
            // alert("Please Enter Sender Name");
            callToastWarnAlert("Invalid! Enter Sender Name",2400);
            requestFocusOnInvalid(event,'senderName');
            return;
        }else if(formValues.senderAddress===''){
            // alert("Please Enter Sender Address");
            callToastWarnAlert("Invalid! Enter Sender Address",2400);
            requestFocusOnInvalid(event,'senderAddress');
            return;
        }

        if(!contactNumberRegex.test(formValues.receiverContact)){
            // alert("Incorrect Receiver Phone number..")
            callToastWarnAlert("Invalid! Receiver Phone number.",2400);
            requestFocusOnInvalid(event,'receiverContact');
            return;
        }
        else if(formValues.receiverName===''){
            // alert("Please Enter Reciever Name");
            callToastWarnAlert("Invalid! Enter Receiver Name.",2400);
            requestFocusOnInvalid(event,'receiverName');
            return;
        }
        else if(formValues.receiverAddress===''){
            // alert("Please Enter Reciever Address");
            callToastWarnAlert("Invalid! Enter Receiver Address.",2400);
            requestFocusOnInvalid(event,'receiverAddress');
            return;
        }

        const isOriginValid = masterData.LIST_PINCODE.find(
                                pin => pin.pin_code === formValues.originPincode
                            );
        if(isOriginValid){
            selectOriginPincode(formValues.originPincode)
        }else{
            // alert("Enter valid Origin pincode")
            callToastWarnAlert("Invalid! Enter Valid Origin pincode",2400);
            requestFocusOnInvalid(event,'originPincode');
            return;
        }         
        const isDestValid = masterData.LIST_PINCODE.find(
                                pin => pin.pin_code === formValues.destPincode
                            );
        if(isDestValid){
            selectOriginPincode(formValues.destPincode)
        }else{
            // alert("Enter valid Destination pincode")
            callToastWarnAlert("Invalid! Enter Valid Destination pincode",2400);
            requestFocusOnInvalid(event,'destPincode');
            setIsSaveDisable(true);
            return;
        }        
       
        const isReceiverPinValid = masterData.LIST_PINCODE.find(
                                pin => pin.pin_code === formValues.receiverPincode
                            );
        if(isReceiverPinValid){
            selectOriginPincode(formValues.receiverPincode)
        }else{
            // alert("Enter valid Receiver pincode")
            callToastWarnAlert("Invalid! Enter Valid Receiver pincode",2400);
            requestFocusOnInvalid(event,'receiverPincode');
            setIsSaveDisable(true);
            return;
        }   

        const isSenderPinValid = masterData.LIST_PINCODE.find(
                                pin => pin.pin_code === formValues.senderPincode
                            );
        if(isSenderPinValid){
            selectOriginPincode(formValues.senderPincode)
        }else{
            // alert("Enter valid Sender pincode")
            callToastWarnAlert("Invalid! Enter Valid Sender pincode",2400);
            requestFocusOnInvalid(event,'senderPincode');
            
            return;
        }

        if(!isAwbExist && entryType==='new'){
            // alert("Enter valid Awb No.")
            callToastWarnAlert("Invalid! Enter valid Awb No.",2400);
            requestFocusOnInvalid(event,'awbNo');
            return;
        }

        
        if(getCookie(USER_TYPE_COOKIE_NAME) === US){
            if(formValues.total > wallet.walletAmount){
            callToastWarnAlert("Insuffcient Wallet balance.",2400);
            return;
            }
        }
        handleSave(event);
    }

    const saveReceiver=async()=>{

        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let col = 'recv_ph,recv_name,recv_addrs,recv_zip,recv_city,recv_state';
            let val = `'${formValues.receiverContact}','${formValues.receiverName}','${formValues.receiverAddress}','${formValues.receiverPincode}','${formValues.receiverCity}','${formValues.receiverState}'`
            let duplicate = 'recv_ph=values(recv_ph),recv_name=values(recv_name),recv_addrs=values(recv_addrs),recv_zip=values(recv_zip),recv_city=values(recv_city),recv_state=values(recv_state)'

            const query  = {'column':col,'value':val,'duplicateKey':duplicate,'tableName':'rd'}
            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(query),
                    key:"checkService",
                    userKey:c[0],
                })
            };

            const path = API_PATH + COMMON_LOADRECIEVERDETAIL + "save";
            const res = await fetch(path, requestOption);
            const data = await res.json();

            console.log("dw "+data);
            if(data==='Entry saved.'){
                loadReceiverAllDetail(store);
            }

        } catch (error) {
            console.log(error);
        }
    }

    const saveSender=async()=>{
        if(formValues.senderContact==='')return;
        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let col = 'ship_ph,ship_name,ship_addrs,ship_zip,ship_city,ship_state';
            let val = `'${formValues.senderContact}','${formValues.senderName}','${formValues.senderAddress}','${formValues.senderPincode}','${formValues.senderCity}','${formValues.senderState}'`
            let duplicate = 'ship_ph=values(ship_ph),ship_name=values(ship_name),ship_addrs=values(ship_addrs),ship_zip=values(ship_zip),ship_city=values(ship_city),ship_state=values(ship_state)'

            const query  = {'column':col,'value':val,'duplicateKey':duplicate,'tableName':'sb'}
            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(query),
                    key:"checkService",
                    userKey:c[0],
                })
            };

            const path = API_PATH + COMMON_LOADSHIPPERDETAIL + "save";
            const res = await fetch(path, requestOption);
            const data = await res.json();

            if(data==='Entry saved.'){
                loadSenderAllDetail(store);
            }
            console.log("dw "+data);

        } catch (error) {
            console.log(error);
        }
    }

    const handleSave=async(event)=>{

        // setFormValues(prev => ({
        //     ...prev,
        //     billingWt: billingWeight
        // }));
        // setLoading(true);
        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            setIsSaveDisable(true);
            return;
        }
        let billingWeight = 0;
        billingWeight = formValues.billingWt;
        console.log("frmvalue",formValues)
        const cleintCode = formValues.client.split("|")[1].trim();
        const networkCode = formValues.network.split("|")[1].trim();
        const serviceCode = formValues.service.split("|")[1].trim();
        // console.log(formValues.tatDate,formValues);
        let formattedDate = '';
        let formattedTatDate = ''
        if(modifying){
            const newDate = new Date(formValues.tatDate);
            const newBokDate = new Date(formValues.date);
            formattedTatDate = newDate.toISOString().split('T')[0];
            formattedDate = newBokDate.toISOString().split('T')[0];
        }else{
            formattedDate = formValues.date.toISOString().split('T')[0];
            formattedTatDate = formValues.tatDate.toISOString().split('T')[0];
        }
        // console.log("consignee flad: "+flagC)
        let specialEntry  = formValues.specialEntry||'';
        let documentType = '';
        if(formValues.docType==='dox'){
            documentType='D'
        }else{
            documentType='N'
        }
        
        
        let serviceGroupCode = getServiceGroupCode();
        let freigth = formValues.friegth?formValues.friegth:0;
        let weigthType = formValues.WEIGHT_SLAB_TYPE;
        let weigthSlab = formValues.WEIGHT_SLAB_AMOUNT;
        let zoneType = formValues.ZONE_CODE;
        let docketCharge = formValues.docketCharge?formValues.docketCharge:0;
        let fuelAmt = formValues.fuelAmt?formValues.fuelAmt:0;
        let fuelRate = formValues.fuelRate?formValues.fuelRate:0;
        let insuranceType = '';
        if(formValues.insurance==='Owner'){
            insuranceType = 'OW';
        }else if(formValues.insurance==='Carrier'){
            insuranceType = 'CA'
        }else {
            insuranceType = 'NA';
        }

        // tax columns
        let taxN1 = formValues.taxName1||'';
        let taxR1 = formValues.taxRate1||0;
        let serviceTax = formValues.service_tax||0;
        let taxN2 = formValues.taxName2||'';
        let taxR2 = formValues.taxRate2||0;
        let eduCess = formValues.edu_cess||0;
        let taxN3 = formValues.taxName3||'';
        let taxR3 = formValues.taxRate3||0;
        let hEduCess = formValues.h_edu_Cess||0;
        let total = formValues.total?formValues.total:0;
        let codAmt = formValues.codAmount||0;
        let codValue = Number(formValues.codValue)||0;
        // const fuelObj = await calculateFuelAmt(masterData,cleintCode,networkCode,serviceGroupCode,freigthAmt,0,formValues.insValue);
        // console.log("fuel AMount===============",fuelObj);
        let commision = 0;
        // if(weigthType==='B'){
        //     commision = getClientCommissionDetails(masterData,cleintCode,weigthSlab,freigthAmt,fuelObj.fuelAmt);
        // }else{
        //     commision = getClientCommissionDetails(masterData,cleintCode,billingWeight,freigthAmt,fuelObj.fuelAmt);
        // }
        // console.log(commision);
        const requestArr = [];
        try{

            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === cleintCode
            );

            let branch = '';
            if(cookieUserType===MMB_LIVE){
                // branch = selectedClient.branch_code;
            }
            else{
                branch = selectedClient.client_type;
            }

            let awbNO = formValues.awbNo;
            // console.log("awbNO for increment ",awbNO);
            // console.log("form",formValues)
            let column = "";
            let duplicateKeyUpdate = ''
            let tableName = '';
            let value = '';
            if(cookieUserType==="MMB_LIVE"){
                return;    

            }
            else{
                tableName = "cb";
                column = "branch_cd,boking_dt,tat_date,awb_no,fwd_no,client_cd,sub_client_cd,destination,network,service,type,pkgs,"
                    + "vol_wt,act_wt,bil_wt,insur_type,insur_value,insur_rate,insur_amt,cod_value,cod_amt,fod_amt,cwc_amt,amount,fuel,"
                    + "service_tax,edu_cess,h_edu_Cess,total,s_cost,user_info,do_in,comments,modify_date,docket_chrg,user_id,"
                    + "special,service_group,zone_type,weight_type,weight_slab,special_ts_amt,ship_ph,tax_name1,tax_name2,tax_name3,"
                    + "tax_rate1,tax_rate2,tax_rate3,state_code,issued_type,book_issued,commssion,origin,recv_ph,oda_amt,pincode,"
                    + "insur_invoice,cwc_fuel,fuel_rate,destination_code,origin_pincode,content,origin_name,application_id";

                duplicateKeyUpdate = "branch_cd=values(branch_cd),awb_no=values(awb_no),boking_dt=values(boking_dt),fwd_no=values(fwd_no),tat_date=values(tat_date),"
                    + "client_cd=values(client_cd),sub_client_cd=values(sub_client_cd),destination=values(destination),network=values(network),service=values(service),type=values(type),pkgs=values(pkgs),"
                    + "vol_wt=values(vol_wt),act_wt=values(act_wt),bil_wt=values(bil_wt),insur_type=values(insur_type),insur_value=values(insur_value),insur_rate=values(insur_rate),insur_amt=values(insur_amt)," 
                    + "cod_amt=values(cod_amt),fod_amt=values(fod_amt),cwc_amt=values(cwc_amt),amount=values(amount),fuel=values(fuel),service_tax=values(service_tax),edu_cess=values(edu_cess),"
                    + "h_edu_Cess=values(h_edu_Cess),total=values(total),s_cost=values(s_cost),user_info=values(user_info),do_in=values(do_in),comments=values(comments),modify_date=values(modify_date),docket_chrg=values(docket_chrg),user_id=values(user_id),"
                    + "special=values(special),service_group=values(service_group),zone_type=values(zone_type),weight_type=values(weight_type),weight_slab=values(weight_slab),special_ts_amt=values(special_ts_amt),ship_ph=values(ship_ph),tax_name1=values(tax_name1),tax_name2=values(tax_name2),tax_name3=values(tax_name3),"
                    + "tax_rate1=values(tax_rate1),tax_rate2=values(tax_rate2),tax_rate3=values(tax_rate3),state_code=values(state_code),issued_type=values(issued_type),book_issued=values(book_issued),commssion=values(commssion),origin=values(origin),recv_ph=values(recv_ph),oda_amt=values(oda_amt),pincode=values(pincode),"
                    + "insur_invoice=values(insur_invoice),cwc_fuel=values(cwc_fuel),fuel_rate=values(fuel_rate),destination_code=values(destination_code),origin_pincode=values(origin_pincode),content=values(content),origin_name=values(origin_name)";
                
                value = `'${branch}','${formattedDate}','${formattedTatDate}','${formValues.awbNo}','${formValues.forwardingNo?formValues.forwardingNo:formValues.awbNo}',
                        '${cleintCode}','${formValues.subClient}','${formValues.destCity}','${networkCode}','${serviceCode}','${documentType}','${formValues.pcs}',
                        '${formValues.volumneWt?formValues.volumneWt:0.0}','${formValues.actualWt?formValues.actualWt:0.0}','${billingWeight}','${insuranceType}',
                        '${formValues.insValue?formValues.insValue:0}','${formValues.insRate?formValues.insRate:0}','${formValues.insAmount?formValues.insAmount:0}',
                        '${codValue}','${codAmt}','${0}','0','${freigth}','${fuelAmt}',
                        '${serviceTax}','${eduCess}','${hEduCess}','${total}','0.0','${c[1]}','DO','${formValues.remarks}',CURRENT_TIMESTAMP,'${docketCharge}','${c[1]}',
                        '${specialEntry}','${serviceGroupCode}','${zoneType?zoneType:''}','${weigthType?weigthType:''}','${weigthSlab?weigthSlab:0}','0','${formValues.senderContact.trim()}','${taxN1}','${taxN2}','${taxN3}',
                        '${taxR1}','${taxR2}','${taxR3}','${formValues.stateCode}','DE','', '${commision}','${formValues.originCityCode}','${formValues.receiverContact.trim()}','0','${formValues.destPincode}',
                        '${formValues.insInvoiceNo}','0','${fuelRate}','${formValues.destCityCode}','${formValues.originPincode}','${formValues.content}','${formValues.originCity}','WEB'` ;
            }
            const objdb = {
                tableName:tableName,
                value:value,
                column:column,
                duplicateKey:duplicateKeyUpdate
            }

            requestArr.push(objdb);
            
            const objdbv = saveDailyBookingVas();
            requestArr.push(objdbv);

            const requestOption = {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestArr),
                    key:"checkService",
                    userKey:c[0]
                })
            }

            const path = API_PATH  + FAST_BOOKING_REQUEST_PATH  + "saveentry";
            const res = await fetch(path,requestOption);
            const data = await res.json();

            // console.log("data db and dbv "+data);
            if(data==='Entry saved.'){
                setIsSaveDisable(true);
                getClientBalance(wallet);
                // bookingViaMoney(wallet,total,formValues.awbNo);
                saveWeigthDimension(); 
                saveSender();
                saveReceiver(); 
                if(printDocket){
                    printJasper(cleintCode,formValues.awbNo)
                    // console.log("just called print api");
                }else{
                    // console.log("not calling print api");
                }
                const message = `Awb: ${awbNO} booked successfully.`
                toast.success(message, {
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                setAwbExists(false);
                resetAction();
                if(modifying){
                    return;
                }
                setFormValues(prev=>({
                    ...prev,
                    'awbNo':incrementAwbNo(awbNO)
                }))
                setTimeout(()=>{
                    requestFocusOnInvalid(event,'awbNo');
                    setIsSaveDisable(true);
                },300)
            }else{
                const message = `Awb: ${awbNO}! Failed to booked.`
                 toast.error(message, {
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
            }

        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
            setIsSaveDisable(true);
        }
    }

    const printJasper=async(clientCode,awbNo)=>{
        try{
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let value = '';
            if(cookieUserType==="MMB_LIVE"){
                return;
                // console.log("Returning print api for fun");
                // value = "where db.awb_no='"+awbNo+"' and db.client_code='" +clientCode+"'";
            }else{
                value = "where cb.awb_no='"+awbNo+"' and client_cd='" +clientCode+"'";
            }
            const requestObj = {"userKey":c[0],"value":value}
            const requestOption = {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestObj),
                    key:"checkService",
                    userType:cookieUserType
                })
            }

            const path = API_PATH  + FAST_BOOKING_DOCKETJASPER + "jasperprint";
            const response = await fetch(path, requestOption);
            const contentType = response.headers.get("Content-Type");
            console.log(contentType);
            if(contentType && contentType.includes('application/octet-stream')){
                    const arrayBuffer = await response.arrayBuffer();
                    const blob = new Blob([arrayBuffer], { type: 'application/pdf' })
                    const url = URL.createObjectURL(blob);

                    // Open PDF immediately
                    window.open(url, "_blank", "noopener,noreferrer,width=800,height=600");
            }else{
                const errText = await response.text();
                // alert(errText)
                callToastErrorAlert(errText,4000);
            }

            
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    const resetAction=()=>{
        let client = masterData.LIST_CLIENT[0];
        setFormValues({
            awbNo:'',
            forwardingNo:'',
            date:date,
            tatDate:date,
            client:`${client.client_name.toUpperCase() + " | " + client.client_code.toUpperCase()}`,
            subClient:'',
            network:SELECT,
            service:SELECT,
            originPincode:'',
            originCity:'',
            originCityCode:'',
            originStateCode:'',
            destPincode:'',
            destCity:'',
            destCityCode:'',
            stateCode:'',
            destStateCode:'',
            docType:'dox',
            lbZone:'',
            pcs:'',
            actualWt:'',
            volumneWt:'',
            billingWt:'',
            docketCharge:0,
            friegth:0,
            WEIGHT_SLAB_AMOUNT:0,
            WEIGHT_SLAB_TYPE:'',
            ZONE_CODE:'',
            fuelAmt:0,
            fuelRate:0,
            insInvoiceNo:'',
            insurance:'NA',
            insAmount:0,
            insValue:'',
            insRate:0,
            senderContact:'',
            senderName:'',
            senderAddress:'',
            senderPincode:'',
            senderCity:'',
            senderState:'',
            receiverContact:'',
            receiverName:'',
            receiverAddress:'',
            receiverPincode:'',
            receiverCity:'',
            receiverState:'',
            content:'',
            remarks:'',
            clientCode:getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : '',
            userType: getCookie(APP_TYPE_COOKIE_NAME),
            taxName1:'',
            taxRate1:0,
            service_tax:0,
            taxName2:'',
            taxRate2:0,
            edu_cess:0,
            taxName3:'',
            taxRate3:0,
            h_edu_Cess:0,
            total:0,
            codValue:0,
            codAmount:0,
            docketCharge:0,
            gstTotal:0
        })

        setWeigthDimension({
            heigth:'',
            width:'',
            length:'',
            actwt:'',
            pcs:'',
            volwt:''
        })
        setPrintDocket(false);
        setEntryType("new");
        setClientSelfSender(false);

        setIsSameAwb('');

        setDimensionList([]);
        // setPiece(0);

        if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){

        }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
            // setClientByUs();
        }

        setDisableAwb(false);
        setModifying(false);
        setModifyingData({});
        setWeigthModifying(false);
        setModifyingWeigth([])
        setIsSaveDisable(true);
    }

    const saveDailyBookingVas=()=>{

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let column = '';
        let tableName=  '';
        let duplicateKeyUpdate  ='';
        let value = '';
        if(cookieUserType==='MMB_LIVE'){
            return;
        }else{
            let formattedDate = '';
            if(modifying){
                const newBokDate = new Date(formValues.date);
                formattedDate = newBokDate.toISOString().split('T')[0];
            }else{
                formattedDate = formValues.date.toISOString().split('T')[0];
            }
            tableName = "cbov";
            column = "awb_no,vas_code,vas_amount,vas_fuel,in_date,user_info";
            value = `'${formValues.awbNo}','','0','0','${formattedDate}','${c[1]}'`;
            duplicateKeyUpdate = "awb_no=values(awb_no),vas_code=values(vas_code),vas_amount=values(vas_amount),vas_fuel=values(vas_fuel),in_date=values(in_date),user_info=values(user_info)"
        }

         

        const obj={
            value:value,
            column:column,
            tableName:tableName,
            duplicateKey:duplicateKeyUpdate
        }

        return obj;

    }

    // const saveDailyBookingStatusSummary=async()=>{

    //     const cookie = getCookie(LOGIN_COOKIE_NAME);
    //     const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
    //     const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

    //     let column = '';
    //     let tableName = '';
    //     if(cookieUserType === 'MMB_LIVE'){
    //         column = "awb_no, pcs, status_date, status_time, delivery_status, branch_code, active_status, create_date, last_modify_date, application_id, last_modified_user, user_history";
    //         tableName = "dbss";
    //     }else if(cookieUserType==='MMB'){
    //         return;
    //     }

    //     const value = `'${formValues.awbNo}','${formValues.pcs}',CURRENT_DATE,CURRENT_TIME,'BOK','${c[3]}','T',CURRENT_DATE,CURRENT_TIMESTAMP,'','',''`;
        
    //     const query={
    //         tableName:tableName,
    //         value:value,
    //         column:column,
    //     }

    //     const requestOption = {
    //     method:"POST",
    //     headers:{
    //         "Content-Type":"application/json"
    //     },
    //     body: new URLSearchParams({
    //         query:JSON.stringify(query),
    //         userKey:c[0],
    //         key:"checkService"
    //     })
    // }

    //     const path = API_PATH  + FAST_BOOKING_REQUEST_PATH  + "savedbss";
    //     const res = await fetch(path,requestOption);
    //     const data = await res.json();
    //     // console.log("data dbss "+data);
        
    // }

    const saveWeigthDimension = async () => {

        if (dimensionList.length === 0) return;

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let requestArr = [];

        if (cookieUserType === 'MMB_LIVE') {
            return;

        }else if(cookieUserType===MMB){
            const masterNo = formValues.awbNo;

            requestArr = dimensionList.map(value => {
                return {
                    awb_no: masterNo,
                    height: Number(value.heigth),
                    width: Number(value.width),
                    length: Number(value.length),
                    pcs: Number(value.pcs),
                    weigth: Number(value.volwt),
                    act_wt: Number(value.actwt),
                };
            });
        }

        try {

            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestArr),
                    key:"checkService",
                    userKey:c[0],
                    masterAwb:formValues.awbNo,
                    apptype:cookieUserType
                })
            };

            const path = API_PATH + WEIGTH_DIMENSION + "save";
            const res = await fetch(path, requestOption);
            const data = await res.json();

            console.log("dw "+data);

        } catch (error) {
            console.log(error);
        }
    };


    const enterDimensionMMB = () => {

    const actwt = Number(weigthDimension.actwt);
    const length = Number(weigthDimension.length);
    const width  = Number(weigthDimension.width);
    const heigth = Number(weigthDimension.heigth);
    const pcs    = Number(weigthDimension.pcs);
    const totalPcs = Number(formValues.pcs);

    if (heigth <= 0) return callToastWarnAlert("Height must be greater than Zero.",2400);
    if (width  <= 0) return alert("Width cannot be zero or negative");
    if (length <= 0) return alert("Length cannot be zero or negative");
    if (actwt  <= 0) return alert("Actual weight cannot be zero or negative");

    let mode = '';
    let service = '';
    if(formValues.service!=="Select..."){
        service = formValues.service.split("|")[1].trim();
    }else{
        // setPiece(0);
        return callToastWarnAlert('Please Select Service.',2400);
    }

    let network = '';
    if(formValues.network!=="Select..."){
        network = formValues.network.split("|")[1].trim();
    }else{
        // alert("Please select network.")
        callToastWarnAlert('Please select network.',2400);
        return;
    }

    // setPiece(peice+pcs)

    const currTotalPcs = dimensionList.reduce((total, item) => {
        return total + Number(item.pcs);
    }, 0);

    if(currTotalPcs+pcs>totalPcs) return alert("Weigth Dimension Pcs is greater than actual pcs");

    // if (pcs > formValues.pcs) {
    //     alert("Pcs is greater than " + formValues.pcs);
    //     return;
    // }
    

    const selectedService = masterData.LIST_SERVICE.find(
        t => t.ser_code === service
    );

    const clientVas = masterData.LIST_CLIENTVAS.find(
        t => t.client_code === formValues.client.split("|")[1].trim()
    );

    const selectedClient = masterData.LIST_CLIENT.find(
        c => c.client_code === formValues.client.split("|")[1].trim()
    );
    if (!clientVas) {
        alert("Client data not found");
        return;
    }

    // let fg = 0;
    // if(selectedClient.dimention_type==="C"){
    //     if ("SF".equals(selectedService.ser_mode)) {
    //         fg = selectedClient.surface_dimension ;
    //     } else {
    //         fg = selectedClient.air_dimension;
    //     }
    // }else{
    //     fg = getServiceAssociatMMBDataFromDb(network,service);
    // }

    let dimantion = 0;
    let wtRoundOff = false;
    let wt = 0;
    if(clientVas.dimension_type==='DIM'){
        wt = clientVas.dimension_value;
    }else{
        wt = clientVas.dimension_value;
    }

    if(wt===0){
        // alert("Error, Dimension value is not set on Client, Network, or Service..");
        callToastErrorAlert('Error, Dimension value is not set on Client, Network, or Service.',2400)
    }else{
        if(clientVas.dimension_type==='DIM'){
            dimantion = (heigth * width * length * pcs)/wt;
        }else{
            let weigth;
            weigth = ((heigth*width*length)/27000)*wt;
            dimantion = weigth*pcs;
        }
    }

    if (!dimantion) {
        // alert("");
        callToastWarnAlert("Dimension factor not found.",2400)
        return;
    }
    
    let weigth = wtRoundOff ? Math.ceil(dimantion) : Number(dimantion.toFixed(2));

    setDimensionList(prev => {

        const updatedList = [
            ...prev,
            {
                ...weigthDimension,
                volwt: weigth
            }
        ];

        const totalactwt = updatedList.reduce(
            (total, item) => total + Number(item.actwt),
            0
        );

        const totalVolwt = updatedList.reduce(
            (total, item) => total + Number(item.volwt),
            0
        );

        setFormValues(prevForm => ({
            ...prevForm,
            actualWt: Number(totalactwt).toFixed(3),
            volumneWt: Number(totalVolwt).toFixed(3)
        }));

        return updatedList;
    });

    setWeigthDimension({
        heigth:'',
        width:'',
        length:'',
        actwt:'',
        pcs:'',
        volwt:''
    })

};


// Remve volumatric dimention
const removeEnteredDimension = (index) => {

    if (window.confirm("Do you want to remove this row?")) {

        const updatedList = dimensionList.filter((_, i) => i !== index);

        setDimensionList(updatedList);

        const totals = updatedList.reduce((acc, item) => {
            acc.act += Number(item.actwt || 0);
            acc.vol += Number(item.volwt || 0);
            return acc;
        }, { act: 0, vol: 0 });

        setFormValues(prev => ({
            ...prev,
            actualWt: totals.act,
            volumneWt: totals.vol
        }));
    }
};

    const [modifyingWeigth,setModifyingWeigth] = useState([]);
    const [weigthModifying,setWeigthModifying] = useState(false);

    // get volumatric dimention for awb modify
const handleWeigthDimenstionFocus=async()=>{
    if(formValues.awbNo==='') return;
    if(weigthModifying)return;
    try{
        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let column=''
        let condition = ''
        let tableBean = ''
        if (c.length === 4) {

            if(cookieUserType==='MMB_LIVE'){
                return;

            }else if(cookieUserType==='MMB'){
                column = "awb_no,height,width,length,pcs,act_weight as act_wt,weight as vol_wt";
                tableBean = "DataEntryBean";
                condition = "where awb_no='" + formValues.awbNo + "'";
            }

            let query = { "userKey": c[0], 'column':column,'value':condition,'beanname':tableBean};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    usertype:cookieUserType
                })
            };
            const path = API_PATH + WEIGTH_DIMENSION + "getweigthData";
            const res = await fetch(path, requestOptions);
            const data = await res.json();

            const response = data[0][tableBean];
            console.log("weigth",response);
            if(response!=="Result Not Found"){
                setWeigthModifying(true)
                setModifyingWeigth(response);
                
                for(let i of response){
                    if(cookieUserType===MMB_LIVE){
                        setDimensionList(prev => {

                            const updatedList = [
                                ...prev,
                                {
                                    heigth:i.height,
                                    width:i.width,
                                    length:i.lenght,
                                    actwt:i.act_wt,
                                    pcs:i.pcs,
                                    volwt:'',
                                    master_awb_no:i.master_awb_no,
                                    sub_awb_no:i.sub_awb_no,
                                    volwt: i.vol_wt
                                }
                            ];

                            const totalactwt = updatedList.reduce(
                                (total, item) => total + Number(item.actwt),
                                0
                            );

                            const totalVolwt = updatedList.reduce(
                                (total, item) => total + Number(item.volwt),
                                0
                            );

                            setFormValues(prevForm => ({
                                ...prevForm,
                                actualWt: totalactwt,
                                volumneWt: totalVolwt
                            }));

                            return updatedList;
                        });
                    }else if(cookieUserType===MMB){
                        setDimensionList(prev => {

                            const updatedList = [
                                ...prev,
                                {
                                    heigth:i.height,
                                    width:i.width,
                                    length:i.length,
                                    actwt:i.act_wt,
                                    pcs:i.pcs,
                                    master_awb_no:i.awb_no,
                                    volwt: i.vol_wt
                                }
                            ];

                            const totalactwt = updatedList.reduce(
                                (total, item) => total + Number(item.actwt),
                                0
                            );

                            const totalVolwt = updatedList.reduce(
                                (total, item) => total + Number(item.volwt),
                                0
                            );

                            setFormValues(prevForm => ({
                                ...prevForm,
                                actualWt: totalactwt,
                                volumneWt: totalVolwt
                            }));

                            return updatedList;
                        });
                    }
                }
            }
        }
    }catch(error){
        console.log(error);
    }
}

// Auto increment Awb no
const incrementAwbNo = (value) => {
  const prefix = value.match(/[A-Za-z]+/)[0];   // Z
  const number = value.match(/\d+/)[0];         // 122
  
  const newNumber = parseInt(number, 10) + 1;

  return prefix + newNumber;
};

// ============================== helper method =====================================================================================

function getServiceGroupCode(){
    const serviceList = masterData.LIST_SERVICE;
    let service = formValues.service?.split("|")[1].trim();
    for(let i of serviceList){
        if(service===i.ser_code){
            service = i.group_code;
            break;
        }
    }
    return service;
}

// ==================================================================================================================================

// ==================================================================================================================================

const handleVolumeEnter= async()=>{
    const actual = Number(formValues.actualWt);
    const volume = Number(formValues.volumneWt);

    let calculateBillingWeight = actual > volume ? formValues.actualWt : formValues.volumneWt;
    setFormValues(prev=>({
        ...prev,
        'billingWt':calculateBillingWeight
    }))

    let billingWeight = Number(calculateBillingWeight)

    const client = formValues.client.split('|')[1].trim();
    const service = formValues.service.split('|')[1].trim();
    const serviceGroup = getServiceGroupCode();
    const network = formValues.network.split('|')[1].trim();
    // let insurType = getInsuranceType(masterData,client,serviceGroup,network)
    // // console.log(client,service,network,serviceGroup)
    // // console.log("insurance",insurType);
    // if(insurType==='OW'){
    //     insurType = 'Owner';
    // }else if(insurType==='CA'){
    //     insurType = 'Carrier';
    // }else{
    //     alert("Client insurance type not found");
    // }
    // setFormValues(prev=>({
    //     ...prev,
    //     'insurance':insurType
    // }))

    let destinationCode = formValues.destCityCode;
    let documentType = '';
    if(formValues.docType==='dox'){
        documentType='D'
    }else{
        documentType='N'
    }
    calculateFreightAmtForCourier(client,network,serviceGroup,destinationCode,billingWeight,documentType)
}

const calculateFreightAmtForCourier = (clientCode,networkCode,serviceGroupCode,destinationCode,billWt,docType)=>{

        let amt = 0;
        let {doZoning,inZoning} = getZoningDetail(masterData);
        console.log("zone in and do", doZoning,inZoning);
        let SE = "SE";
        let ZO = "ZO";
        let ZONE_CODE = "";
        let SERVICE_GROUP_CODE = "";
        let WEIGHT_SLAB_TYPE = "";
        let WEIGHT_SLAB_AMOUNT = 0;
        let doIn = 'DO';

        console.log(destinationCode)

        let hashMap_ClientRatesCourier = list_clientRatesCourier;
        let rateList = getClientRateCourier(hashMap_ClientRatesCourier,clientCode,networkCode,serviceGroupCode,SE,destinationCode)
        console.log("getClientRateCourier",rateList);
        console.log("hashMap_client",hashMap_ClientRatesCourier);
        if(!rateList){
            let lstZone = [];
            if ('DO'==doIn) {
                lstZone = doZoning.get(destinationCode);
            } else if ("IN"==doIn) {
                lstZone = inZoning.get(destinationCode);
            }
            console.log(lstZone);
            if (lstZone !== null && lstZone.length>0) {
                for (let zone of lstZone) {
                    if (checkClientRateCourier(hashMap_ClientRatesCourier, clientCode, networkCode, serviceGroupCode, ZO, zone)) {
                        console.log("in tis if of checkClientRateCourier to get again rateList")
                        ZONE_CODE = zone;
                        SERVICE_GROUP_CODE = serviceGroupCode;
                        rateList = getClientRateCourier(hashMap_ClientRatesCourier, clientCode, networkCode, serviceGroupCode, ZO, zone);
                        break;
                    }
                }
            }
        }
        console.log(rateList);

        if(!rateList){

            let special = '';
            if(amt<=0){
                special = 'T'
            }else {
                special = 'F'
            }
            setFormValues(prev=>({
                ...prev,
                'specialEntry':special,
                'friegth':amt.toFixed(2),
                'WEIGHT_SLAB_TYPE':WEIGHT_SLAB_TYPE,
                'WEIGHT_SLAB_AMOUNT':WEIGHT_SLAB_AMOUNT,
                'ZONE_CODE':ZONE_CODE
            }))
            return;
        }

        let rateApplied = true;
        let B = "B", A = "A", K = "K";
        let doxRate = 0, nonDoxRate = 0;
        let highestBasicSlabWt = 0, highestBasicSlabDoxRate = 0, highestBasicSlabNonDoxRate = 0;

        for (let bean of rateList) {
            if (bean.rate_type === B) {
                if (billWt >= bean.weight_from && billWt <= bean.weight_to) {
                    rateApplied = false;
                    doxRate = bean.dox;
                    nonDoxRate = bean.nondox;
                    WEIGHT_SLAB_TYPE = bean.rate_type;
                    WEIGHT_SLAB_AMOUNT = bean.dox;
                    break;
                }
                highestBasicSlabWt = bean.weight_to;
                highestBasicSlabDoxRate = bean.dox;
                highestBasicSlabNonDoxRate = bean.nondox;

            }
        }


        if (rateApplied) {
            for (let bean of rateList) {
                if (bean.rate_type === A && billWt <= bean.weight_from) {
                    rateApplied = false;
                    let z = (billWt - highestBasicSlabWt) / bean.weight_to;
                    let slot = z;
                    console.log((billWt - highestBasicSlabWt) % bean.weight_to);
                    if ((billWt - highestBasicSlabWt) % bean.weight_to > 0) {
                        slot++;
                    }
                    doxRate = highestBasicSlabDoxRate + (slot * bean.dox);
                    nonDoxRate = highestBasicSlabNonDoxRate + (slot * bean.nondox);
                    WEIGHT_SLAB_TYPE = bean.rate_type;
                    WEIGHT_SLAB_AMOUNT = bean.dox;
                    break;
                }
            }
        }
        if (rateApplied) {
            for (let bean of rateList) {
                if (bean.rate_type === K) {
                    if (billWt >= bean.weight_from && billWt <= bean.weight_to) {
                        doxRate = Math.ceil(billWt) * bean.dox;
                        nonDoxRate = Math.ceil(billWt) * bean.nondox;
                        WEIGHT_SLAB_TYPE = bean.rate_type;
                        WEIGHT_SLAB_AMOUNT = bean.dox;
                        break;
                    }
                }
            }
        }

        
        if (docType=="D") {
            amt = doxRate;
        } else if (docType=="N") {
            amt = nonDoxRate;
        }
        console.log("freigth weigthType weigthSlab zoneCode, lbzone",amt,WEIGHT_SLAB_TYPE,WEIGHT_SLAB_AMOUNT,ZONE_CODE,formValues.lbZone);

        let special = '';
        if(amt<=0){
            special = 'T'
        }else {
            special = 'F'
        }
        setFormValues(prev=>({
            ...prev,
            'specialEntry':special,
            'friegth':amt.toFixed(2),
            'WEIGHT_SLAB_TYPE':WEIGHT_SLAB_TYPE,
            'WEIGHT_SLAB_AMOUNT':WEIGHT_SLAB_AMOUNT,
            'ZONE_CODE':ZONE_CODE
        }))
        return;   
}

function getDocketChargeAndCodAmt(clientCode,service,network,codVal) {
    let docketCharge = 0;
    let hashmap_clientVas = new Map();
    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === clientCode){
            if (clientVas.service_group_code === service && clientVas.network_code === network) {
                docketCharge = clientVas ? clientVas.docket_amount : 0;
                let codFixed = clientVas.cod_fixed;
                let codPercentage = clientVas.cod_percent;

                let tempCodeValue = (codVal * codPercentage)/100;
                console.log("tempCodeValue",tempCodeValue);

                console.log("bean",clientVas)
                
                setFormValues(prev=>({
                    ...prev,
                    'docketCharge':docketCharge.toFixed(2),
                    // 'codAmount': tempCodeValue > codFixed? tempCodeValue.toFixed(2) : codFixed.toFixed(2),
                    'codAmount':codVal > 0 ? tempCodeValue > codFixed? tempCodeValue.toFixed(2) : codFixed.toFixed(2):0
                }))
                return;
            }

            else if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }
    // console.log(hashmap_clientVas);

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);
    docketCharge = Number(bean?.docket_amount ?? 0);
    codVal = Number(codVal) || 0;

    let codFixed = bean.cod_fixed;
    let codPercentage = bean.cod_percent;

    let tempCodeValue = (codVal * codPercentage)/100;
    
    console.log("bean",bean)
    setFormValues(prev=>({
        ...prev,
        'docketCharge':docketCharge.toFixed(2),
        // 'codAmount': tempCodeValue > codFixed? tempCodeValue.toFixed(2) : codFixed.toFixed(2)
        'codAmount':codVal > 0 ? tempCodeValue > codFixed? tempCodeValue.toFixed(2) : codFixed.toFixed(2):0
    }))
    return ;
}

function getFuelAmount(clientCode,service,network,freigthAmt,insValue,docketCharge,fodVal,codAmt) {
    let fuelAmt = 0;
    let hashmap_clientVas = new Map();
    docketCharge = Number(docketCharge);
    freigthAmt = Number(freigthAmt) || 0;
    insValue = Number(insValue) || 0;
    fodVal = Number(fodVal) || 0;
    codAmt = Number(codAmt) || 0;
    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === clientCode){
            if (clientVas.service_group_code === service && clientVas.network_code === network) {

                let fuelRate = clientVas.fuel_rate;

                if(clientVas.fuel_on_vas === 'YES'){
                fuelAmt = ((freigthAmt + docketCharge + insValue + fodVal + codAmt) * fuelRate )/100
                }else{
                    fuelAmt = (freigthAmt *fuelRate)/100;
                }

                

                console.log("bean",clientVas)
                setFormValues(prev=>({
                    ...prev,
                    'fuelAmt':fuelAmt.toFixed(2),
                    'fuelRate':fuelRate,
                }))
                return fuelAmount;
            }

            if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }
    // console.log(hashmap_clientVas);

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);
    
    let fuelRate = Number(bean?.fuel_rate ?? 0);
    let fuelOnVas = bean?.fuel_on_vas ?? 'NO';
    

    console.log(freigthAmt+"enter in frie");
    if(fuelOnVas === 'YES'){
    fuelAmt = ((freigthAmt + docketCharge + insValue + fodVal + codAmt) * fuelRate )/100
    }else{
        fuelAmt = (freigthAmt *fuelRate)/100;
    }
    console.log(fuelAmt,"fuelAmt in get method");
    
    console.log("bean",bean)
    setFormValues(prev=>({
        ...prev,
        'fuelAmt':fuelAmt.toFixed(2),
        'fuelRate':fuelRate,
    }))
    return fuelAmt;
}

async function calculateTax(fuelAmount) {
    let clientCode = formValues.client?.split("|")[1]?.trim();
    let freigth = Number(formValues.friegth);
    let docketChrg = Number(formValues.docketCharge);
    let insval = Number(formValues.insAmount||0);
    let fuelAmt = Number(fuelAmount);
    let codAmount = Number(formValues.codAmount);
    let tax = 0;
    let beanCl;
    for(let client of masterData.LIST_CLIENT){
        if(client.client_code === clientCode){
            beanCl = client;
            break;
        }
    }

    if(!beanCl)return;

    let taxObject = await getTaxSeriesFromDb();
    if(taxObject.length===0)return alert("Tax data detail not found");

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    let cgstTax = taxObject[0].tax_rate;
    let sgstTax = taxObject[0].edu_cess_rate;
    let igstTax = taxObject[0].higher_cess_rate;

    console.log("beanCl",beanCl);
    const company = await getCompanyFromDb(beanCl.client_type);

    console.log('freigth',freigth);
    console.log('docketChrg',docketChrg);
    console.log('insval',insval);
    console.log('fuelAmt',fuelAmt);

    let taxableAmount = freigth + docketChrg + insval + fuelAmt + codAmount;

    let clientStateCode = '';
    let compStateCode = company[0].stateCode;
    for(let pin of masterData.LIST_PINCODE){
        if(pin.pin_code === beanCl.zip_code){
            clientStateCode = pin.state_code;
            break;
        }
    }

    console.log('clientState',clientStateCode);
    console.log('comp',company[0].stateCode);
    if(clientStateCode === compStateCode){
        cgst = (taxableAmount * cgstTax)/100;
        sgst = (taxableAmount * sgstTax)/100;
    }else{
        igst = (taxableAmount * igstTax)/100;
    }

    let totalTax = cgst + sgst + igst;
    let finalAmount = taxableAmount + totalTax;
    console.log(finalAmount+"finalAMt");
    console.log(totalTax+"totalTax");
    console.log(taxableAmount+"taxableAmt")
    setFormValues(prev=>({
        ...prev,
        'taxName1':taxObject[0].tax_name,
        'taxRate1':cgst,
        'taxName2':taxObject[0].edu_name,
        'taxRate2':sgstTax,
        'taxName3':taxObject[0].h_edu_name,
        'taxRate3':igstTax,
        'service_tax':cgst,
        'edu_cess':sgst,
        'h_edu_Cess':igst,
        'total':finalAmount.toFixed(2),
        'gstTotal':totalTax.toFixed(2)
    }))
}

const setClientInsuranceType=()=>{

    let client = formValues.client?.split("|")[1]?.trim();
    let network = formValues.network?.split("|")[1]?.trim();
    let service = formValues.service?.split("|")[1]?.trim();

    let hashmap_clientVas = new Map();

    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === client){
            if (clientVas.service_group_code === service && clientVas.network_code === network) {

                console.log("clientVas",clientVas)
                let insuranceType = "NA";
                if(clientVas.insurance_type==='OW'){
                    insuranceType = "Owner";
                }else if(clientVas.insurance_type === 'CA'){
                    insuranceType = "Carrier";
                }
                setFormValues(prev=>({
                    ...prev,
                    'insurance':insuranceType
                }))
                return;
            }

            else if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);

    console.log("bean",bean)
    let insuranceType = "NA";
    if(bean.insurance_type==='OW'){
        insuranceType = "Owner";
    }else if(bean.insurance_type === 'CA'){
        insuranceType = "Carrier";
    }
    setFormValues(prev=>({
        ...prev,
        'insurance':insuranceType
    }))
    return;
}

const calculateInsuranceAmount=()=>{
    let client = formValues.client?.split("|")[1]?.trim();
    let network = formValues.network?.split("|")[1]?.trim();
    let service = formValues.service?.split("|")[1]?.trim();
    let insuranceValue = Number(formValues.insValue||0);

    let hashmap_clientVas = new Map();

    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === client){
            if (clientVas.service_group_code === service && clientVas.network_code === network) {

                if(formValues.insurance === 'Owner'){
                    let insAmt = (insuranceValue * clientVas.owner_insur_percent)/100;
                    setFormValues(prev=>({
                        ...prev,
                        'insRate':clientVas.owner_insur_percent,
                        'insAmount':insAmt > clientVas.owner_insur_fixed? insAmt.toFixed(2) : clientVas.owner_insur_fixed
                    }))
                    return;
                }else if(formValues.insurance==='Carrier'){
                    let insAmt = (insuranceValue * clientVas.carrier_insur_percent)/100;
                    setFormValues(prev=>({
                        ...prev,
                        'insRate':clientVas.carrier_insur_percent,
                        'insAmount':insAmt > clientVas.carrier_insur_fixed? insAmt.toFixed(2) : clientVas.carrier_insur_fixed
                    }))
                    return;
                }
                
            }

            else if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);

    console.log("bean",bean)

    if(formValues.insurance === 'Owner'){
        let insAmt = (insuranceValue * bean.owner_insur_percent)/100;
        setFormValues(prev=>({
            ...prev,
            'insRate':bean.owner_insur_percent,
            'insAmount':insAmt > bean.owner_insur_fixed? insAmt.toFixed(2) : bean.owner_insur_fixed
        }))
        return;
    }else if(formValues.insurance==='Carrier'){
        let insAmt = (insuranceValue * bean.carrier_insur_percent)/100;
        setFormValues(prev=>({
            ...prev,
            'insRate':bean.carrier_insur_percent,
            'insAmount':insAmt > bean.carrier_insur_fixed? insAmt.toFixed(2) : bean.carrier_insur_fixed
        }))
        return;
    }
    return;
}

  return {formValues,setDate,loading,setLoading,setFormValues,originPin,pincodeList,filteredOriginPincodes,setFilteredOriginPincodes,filteredDestPincodes,setFilteredDestPincodes,handleBlurPincode,handleInputChange,client,setClient,clientOption,service,network,activeOriginIndex,setActiveOriginIndex,selectOriginPincode,selectDestPincode,setActiveDestIndex,activeDestIndex,handleDecimalInputChange,handleNumberInputChange,checkValidation,resetAction,awbBlurHandle,betterLoggerFunction,weigthDimension,setWeigthDimension,enterDimensionMMB,handleWeigthDecimalInputChange,dimensionList,setDimensionList,showDimensionWeigthModal,setShowDimensionWeigthModal,disableAwb,handleWeigthDimenstionFocus,isSaveDisable,removeEnteredDimension,setFuelAmount,handleBlurOfVolumeWt,printDocket,handleBlurReceiver,handleBlurSender,insurType,setFilteredReceiverPincodes,filterReceiverPincodes,setFilteredSenderPincodes,filterSenderPincodes,activeReceiverIndex,setActiveReceiverIndex,activeSenderIndex,setActiveSenderIndex,selectReceiverPincode,selectSenderPincode,filteredSenderPincodes,filteredReceiverPincodes,handleEnterAsTab, dateRef,originPincodeRef,destPincodeRef,senderPincodeRef,receiverPincodeRef,handleEntryChange,isNew,isModify,entryType,handleNewModifyAwb,handleEnterAsTabForVolumatric,clientSelfSender,focusVolumeWeigth,setFocusVolumeWeigth}
}

export default CreditBookingController
